/**
 * Plaatsnamen voor `buitenland.ts`. Overgenomen uit open bronnen, niet met de hand
 * samengesteld — maar wel gewoon te bewerken: het is een lijst en geen bouwsel.
 *
 * Ontbreekt er een Nederlandse woonplaats, dan meldt de app een binnenlandse
 * tankbeurt als buitenland. Zet hem er dan bij, genormaliseerd zoals hieronder.
 *
 * ### Waar het vandaan komt
 *
 * - **Woonplaatsen**: github.com/mvanl94/Lijst-Woonplaatsen-Nederland- — de kolom
 *   `Plaats`. Friese namen staan er dubbel in (`Joure / De Jouwer`); beide helften
 *   zijn opgenomen, want de factuur kan er elke van gebruiken.
 * - **Naamgenoten**: download.geonames.org, de landbestanden BE, LU, DE en FR,
 *   alleen klasse `P` (steden en dorpen; de rest is water, bergen en gebouwen) en
 *   alleen de echte naam — niet de ASCII-vorm die GeoNames ernaast zet, want daar
 *   wordt `Gröningen` `Groningen` en `Wörden` `Woerden`.
 *
 * ### Hoe ze genormaliseerd zijn
 *
 * Hoofdletters, alles wat geen letter of cijfer is wordt een spatie, **en accenten
 * blijven staan** — dezelfde bewerking als `normPlaats`. Namen korter dan drie
 * tekens zijn overgeslagen: dat zijn afkortingen uit stationsnamen, en die zouden
 * hele buitenlandse regels als Nederlands bestempelen.
 *
 * ### Waarom accenten blijven staan
 *
 * Omdat de factuur ze ook schrijft: er staat letterlijk `SAINT-VIÂTRE` in onze data.
 * Zou je ze wegstrepen, dan wordt het Franse `Méteren` het Gelderse `Meteren` en het
 * Duitse `Lünen` het Gelderse `Lunen` — allebei stilletjes "Nederland", en dan zie je
 * een buitenlandse laadbeurt nergens meer. Een gemiste melding is duurder dan een
 * valse, want een valse zie je staan.
 *
 * Van de Nederlandse namen staat de accentloze vorm er ook in (112 stuks), zodat een
 * leverancier die `Skarsterlan` schrijft in plaats van `Skarsterlân` geen vals alarm
 * geeft. Andersom kan dat niet misgaan: een buitenlandse naam mét accent matcht die
 * kale vorm nooit.
 */
/** Elke Nederlandse woonplaats. 5976 namen. */
export const WOONPLAATSEN = [
    '1E EXLOERMOND',
    '1E EXLOËRMOND',
    '2E EXLOERMOND',
    '2E EXLOËRMOND',
    '2E VALTHERMOND',
    '2E VLOTBRUG',
    'AADORP',
    'AAGTEKERKE',
    'AALBEEK',
    'AALDEN',
    'AALDONK',
    'AALSMEER',
    'AALSMEERDERBRUG',
    'AALST',
    'AALSUM',
    'AALTEN',
    'AAM',
    'AAN DE BERG',
    'AAN DE BERGEN',
    'AAN DE MAAS',
    'AAN DE POPELAAR',
    'AAN DE RIJKSWEG',
    'AAN DE SCHOOL',
    'AAN DE ZUWE',
    'AAN REIJANS',
    'AANSCHOT',
    'AARDENBURG',
    'AARLANDERVEEN',
    'AARLE',
    'AARLE RIXTEL',
    'AARTSWOUD',
    'AASTERBERG',
    'ABBEGA',
    'ABBEGAASTERKETTING',
    'ABBEGEA',
    'ABBEGEASTERKEATTING',
    'ABBEKERK',
    'ABBEKINDEREN',
    'ABBENBROEK',
    'ABBENES',
    'ABBENGAWIER',
    'ABBENWIER',
    'ABBESTEDE',
    'ABBEWEER',
    'ABBEWIER',
    'ABCOUDE',
    'ABCOVEN',
    'ABSDALE',
    'ABSHOVEN',
    'ABTSWOUDE',
    'ACHLUM',
    'ACHT',
    'ACHTER HET KLOOSTER',
    'ACHTER LINDT',
    'ACHTER THESINGE',
    'ACHTERBERG',
    'ACHTERBOS',
    'ACHTERBOSCH',
    'ACHTERBROEK',
    'ACHTERDIEP',
    'ACHTERDIJK',
    'ACHTERDREMPT',
    'ACHTEREIND',
    'ACHTERHOEK',
    'ACHTERSTE BRUG',
    'ACHTERSTE DIESDONK',
    'ACHTERSTE ERM',
    'ACHTERSTE HEIDE',
    'ACHTERSTE HEIKANT',
    'ACHTERSTE HERMALEN',
    'ACHTERSTE RITH',
    'ACHTERSTEHOEK',
    'ACHTERVELD',
    'ACHTERWETERING',
    'ACHTHOVEN',
    'ACHTHOVEN WEST',
    'ACHTHUIZEN',
    'ACHTMAAL',
    'ACHTTIENHOVEN',
    'ACQUOY',
    'ADORP',
    'ADUARD',
    'ADUARDERZIJL',
    'AEGUM',
    'AEKINGA',
    'AERDENBURG',
    'AERDENHOUT',
    'AERDT',
    'AFFERDEN',
    'AGELO',
    'AGODORP',
    'AIJEN',
    'AKERSLOOT',
    'AKKER',
    'AKKERPUT',
    'AKKRUM',
    'AKMARIJP',
    'ALBERGEN',
    'ALBLASSERDAM',
    'ALD TERP',
    'ALDE LEIE',
    'ALDE OUWER',
    'ALDE SKOU',
    'ALDEBERKEAP',
    'ALDEBILTSYL',
    'ALDEBOARN',
    'ALDEGEA',
    'ALDEHASKE',
    'ALDEHOLTPEA',
    'ALDEHOLTWALDE',
    'ALDEHOLTWÂLDE',
    'ALDEMARDUM',
    'ALDETRINE',
    'ALDEWEISTERFEART',
    'ALDHOARNE',
    'ALDLEMMER',
    'ALDSKOAT',
    'ALDTSJERK',
    'ALDWALD',
    'ALDWALDMERSYL',
    'ALDWÂLD',
    'ALDWÂLDMERSYL',
    'ALEM',
    'ALENDORP',
    'ALINGHUIZEN',
    'ALKMAAR',
    'ALLERSMA',
    'ALLINGAWIER',
    'ALMELO',
    'ALMEN',
    'ALMERE',
    'ALMERE BUITEN',
    'ALMERE HAVEN',
    'ALMERE HOUT',
    'ALMERE PAMPUS',
    'ALMERE POORT',
    'ALMERE STAD',
    'ALMKERK',
    'ALPHEN',
    'ALPHEN AAN DEN RIJN',
    'ALPHEN OOSTERWIJK',
    'ALTENA',
    'ALTEVEER',
    'ALTFORST',
    'ALTING',
    'ALTWEERT',
    'ALTWEERTERHEIDE',
    'ALVERNA',
    'ALVERSHOOL',
    'AMBT DELDEN',
    'AMEIDE',
    'AMEN',
    'AMERICA',
    'AMERIKA',
    'AMERONGEN',
    'AMERSFOORT',
    'AMMERSTOL',
    'AMMERZODEN',
    'AMPSEN',
    'AMSTELHOEK',
    'AMSTELVEEN',
    'AMSTENRADE',
    'AMSTERDAM',
    'AMSTERDAM DUIVENDRECHT',
    'AMSTERDAMSCHEVELD',
    'AMSWEER',
    'ANDEL',
    'ANDELST',
    'ANDEREN',
    'ANDIJK',
    'ANE',
    'ANERVEEN',
    'ANEVELDE',
    'ANGEREN',
    'ANGERLO',
    'ANHOLT',
    'ANJUM',
    'ANKEVEEN',
    'ANKUM',
    'ANLOO',
    'ANNA JACOBAPOLDER',
    'ANNA PAULOWNA',
    'ANNABUORREN',
    'ANNEN',
    'ANNENDAAL',
    'ANNERVEENSCHEKANAAL',
    'ANNEVILLE',
    'ANREEP',
    'ANSEN',
    'APELDOORN',
    'APENHUIZEN',
    'APPEL',
    'APPELSCHA',
    'APPELSKEA',
    'APPELTERN',
    'APPEN',
    'APPINGEDAM',
    'ARCEN',
    'ARCHEM',
    'ARENDNEST',
    'ARENSGENHOUT',
    'ARKEL',
    'ARKENS',
    'ARMHOEDE',
    'ARMWEIDE',
    'ARNEMUIDEN',
    'ARNHEM',
    'ARNOUD',
    'ARRIEN',
    'ARRIERVELD',
    'ARRIËN',
    'ARRIËRVELD',
    'ARUM',
    'ARWERD',
    'ASBROEK',
    'ASCH',
    'ASENRAY',
    'ASPEREN',
    'ASSCHAT',
    'ASSEL',
    'ASSELT',
    'ASSEN',
    'ASSENDELFT',
    'ASTEN',
    'ATZEBUREN',
    'AUGSBUURT',
    'AUGSBUURT LUTJEWOUDE',
    'AUGUSTINUSGA',
    'AUSTERLITZ',
    'AVENHORN',
    'AVERLO',
    'AVEST',
    'AXEL',
    'AZELO',
    'AZEWIJN',
    'BAAIDUINEN',
    'BAAIDUNEN',
    'BAAIDÚNEN',
    'BAAIUM',
    'BAAK',
    'BAAKHOVEN',
    'BAAKS',
    'BAAKWONING',
    'BAAL',
    'BAALHOEK',
    'BAAMBRUGGE',
    'BAAMBRUGSE ZUWE',
    'BAAMSUM',
    'BAANHOEK',
    'BAARD',
    'BAARDBUORREN',
    'BAARDERBUREN',
    'BAARLAND',
    'BAARLE NASSAU',
    'BAARLO',
    'BAARN',
    'BAARS',
    'BAARSCHOT',
    'BAARSDORP',
    'BAARSTRAAT',
    'BABBERICH',
    'BABUREN',
    'BABYLONIENBROEK',
    'BABYLONIËNBROEK',
    'BAD NIEUWESCHANS',
    'BADHOEVEDORP',
    'BAERD',
    'BAEXEM',
    'BAFLO',
    'BAHR',
    'BAIJUM',
    'BAKEL',
    'BAKELSEBRUG',
    'BAKENDORP',
    'BAKERTAND',
    'BAKHUISBOS',
    'BAKHUIZEN',
    'BAKHUZEN',
    'BAKHÚZEN',
    'BAKKEFEAN',
    'BAKKEROM',
    'BAKKERSDAM',
    'BAKKEVEEN',
    'BALGOIJ',
    'BALHOFSTEDE',
    'BALINGE',
    'BALK',
    'BALKBRUG',
    'BALLAST',
    'BALLEMAN',
    'BALLINGBUER',
    'BALLINGBUUR',
    'BALLOO',
    'BALLUM',
    'BALMAHUIZEN',
    'BANEHEIDE',
    'BANHOLT',
    'BANKERT',
    'BANT',
    'BANTEGA',
    'BANTEGEA',
    'BARCHEM',
    'BARENDRECHT',
    'BARENDRECHTSE VEER',
    'BAREVELD',
    'BARGEBEK',
    'BARGER COMPASCUUM',
    'BARGER ERFSCHEIDENVEEN',
    'BARGER OOSTERVEEN',
    'BARLAGE',
    'BARLAQUE',
    'BARLO',
    'BARNEVELD',
    'BARNFLAIR',
    'BARRIER',
    'BARSBEEK',
    'BARSINGERHORN',
    'BARTLEHIEM',
    'BARWOUTSWAARDER',
    'BASSE',
    'BASSERVELD',
    'BATENBURG',
    'BATH',
    'BATHMEN',
    'BATTENOORD',
    'BAVEL',
    'BAVEL AC',
    'BAVINKEL',
    'BAZUIN',
    'BEARS',
    'BECKUM',
    'BEDAF',
    'BEDUM',
    'BEEGDEN',
    'BEEK',
    'BEEK EN DONK',
    'BEEKBERGEN',
    'BEEKDORP',
    'BEEKHEUVEL',
    'BEEKKANT',
    'BEEMDKANT',
    'BEEMTE',
    'BEEMTE BROEKLAND',
    'BEERENPLAAT',
    'BEERS',
    'BEERSCHOTEN',
    'BEERSTERHOOGEN',
    'BEERTA',
    'BEERTSENHOVEN',
    'BEERZE',
    'BEERZERVELD',
    'BEESD',
    'BEESEL',
    'BEETGUM',
    'BEETGUMERMOLEN',
    'BEETS',
    'BEETSTERSWEACH',
    'BEETSTERZWAAG',
    'BEHELP',
    'BEILEN',
    'BEILERVAART',
    'BEINSDORP',
    'BEINUM',
    'BEKELAAR',
    'BEKENES',
    'BEKVELD',
    'BELDERT',
    'BELFELD',
    'BELGENHOEK',
    'BELGEREN',
    'BELLINGWOLDE',
    'BELT SCHUTSLOOT',
    'BELTRUM',
    'BELVERT',
    'BEMELEN',
    'BEMMEL',
    'BEMMER',
    'BENDERSE',
    'BENEDEN HAASTRECHT',
    'BENEDEN LEEUWEN',
    'BENEDEN VEENSLOOT',
    'BENEDENBERG',
    'BENEDENEIND',
    'BENEDENHEUL',
    'BENEDENKERK',
    'BENNEBROEK',
    'BENNEKOM',
    'BENNEVELD',
    'BENNINGBROEK',
    'BENSCHOP',
    'BENT',
    'BENTELO',
    'BENTHEM',
    'BENTHUIZEN',
    'BENTVELD',
    'BENZENRADE',
    'BERENBROEK',
    'BERG',
    'BERG EN DAL',
    'BERG EN TERBLIJT',
    'BERGAKKER',
    'BERGAMBACHT',
    'BERGEIJK',
    'BERGEN',
    'BERGEN AAN ZEE',
    'BERGEN OP ZOOM',
    'BERGENHUIZEN',
    'BERGENSHUIZEN',
    'BERGENTHEIM',
    'BERGERDEN',
    'BERGHAREN',
    'BERGHEM',
    'BERGHUIZEN',
    'BERGHUM',
    'BERGSCHE HEIDE',
    'BERGSCHENHOEK',
    'BERGSTOEP',
    'BERGUM',
    'BERIK',
    'BERINGE',
    'BERKEIND',
    'BERKEINDJE',
    'BERKEL EN RODENRIJS',
    'BERKEL ENSCHOT',
    'BERKELAAR',
    'BERKENWOUDE',
    'BERKHOEK',
    'BERKHOUT',
    'BERKT',
    'BERLICUM',
    'BERLIKUM',
    'BERLTSUM',
    'BERN',
    'BERNSTERBUREN',
    'BESSELAAR',
    'BEST',
    'BESTHMEN',
    'BESWERD',
    'BETHLEHEM',
    'BETTERWIRD',
    'BETTERWURD',
    'BEUGEN',
    'BEUGT',
    'BEUKELAAR',
    'BEUNINGEN',
    'BEUSBERGEN',
    'BEUSEBERG',
    'BEUSICHEM',
    'BEUTENAKEN',
    'BEVERMEER',
    'BEVERWIJK',
    'BIDDINGHUIZEN',
    'BIERT',
    'BIERUM',
    'BIERVLIET',
    'BIESSTRAAT',
    'BIESSUM',
    'BIEST HOUTHAKKER',
    'BIESTHOEK',
    'BIESTRAAT',
    'BIEZELINGE',
    'BIEZEN',
    'BIEZENHEUVEL',
    'BIEZENMORTEL',
    'BIGGEKERKE',
    'BIJSTEREN',
    'BIJSTERVELD',
    'BIKBERGEN',
    'BIKKERSHORN',
    'BILDERDAM',
    'BILLINGHUIZEN',
    'BILT',
    'BILTHOVEN',
    'BINGELRADE',
    'BINGERDEN',
    'BINNEN MOERDIJK',
    'BIRDAARD',
    'BIRSTUM',
    'BISSCHOPSWETERING',
    'BISSELT',
    'BISSEN',
    'BITGUM',
    'BITGUMMOLE',
    'BLAAKSEDIJK',
    'BLADEL',
    'BLAKER',
    'BLANKENBERG',
    'BLANKENHAM',
    'BLARICUM',
    'BLAUFORLAET',
    'BLAUHUS',
    'BLAUHÛS',
    'BLAUW',
    'BLAUWE HAND',
    'BLAUWE SLUIS',
    'BLAUWENHOEK',
    'BLAUWESLUIS',
    'BLAUWESTAD',
    'BLAUWEWIJK',
    'BLAUWHUIS',
    'BLAUWKAPEL',
    'BLAUWVERLAAT',
    'BLEIJENBEEK',
    'BLEIJS',
    'BLEISWIJK',
    'BLEKSLAGE',
    'BLENKERT',
    'BLERICK',
    'BLESDIJKE',
    'BLESDIKE',
    'BLESKENSGRAAF',
    'BLESKENSGRAAF CA',
    'BLESSUM',
    'BLIJA',
    'BLIJDENSTEIN',
    'BLIJE',
    'BLIJHAM',
    'BLITTERSWIJCK',
    'BLOEMBERG',
    'BLOEMENDAAL',
    'BLOKKER',
    'BLOKLAND',
    'BLOKUM',
    'BLOKZIJL',
    'BOALSERT',
    'BOARNBURGUM',
    'BOARNSWEACH',
    'BOARNSWEACH OER DE WIELEN',
    'BOARNWERT',
    'BOARNWERTHUZEN',
    'BOATEBUORREN',
    'BOAZUM',
    'BOCHOLTZ',
    'BOCHOLTZERHEIDE',
    'BODDENBROEK',
    'BODEGRAVEN',
    'BOEIINK',
    'BOEKEL',
    'BOEKELO',
    'BOEKELTE',
    'BOEKEND',
    'BOEKHORST',
    'BOELENSLAAN',
    'BOELENSLOANE',
    'BOER',
    'BOERAKKER',
    'BOERDONK',
    'BOERELAAN',
    'BOERENGAT',
    'BOERENHOEK',
    'BOERENHOL',
    'BOERENSTREEK',
    'BOERHAAR',
    'BOERMASTREEK',
    'BOESINGHELIEDE',
    'BOIJL',
    'BOKHOVEN',
    'BOKSHEIDE',
    'BOKSUM',
    'BOKT',
    'BOLBERG',
    'BOLENBERG',
    'BOLLINGAWIER',
    'BOLLINGWIER',
    'BOLNES',
    'BOLSHUIZEN',
    'BOLST',
    'BOLSWARD',
    'BOMMELSKOUS',
    'BOMMERIG',
    'BONG',
    'BONKWERD',
    'BONKWERT',
    'BONNERVEEN',
    'BONREPAS',
    'BONTEBOK',
    'BONTEBRUG',
    'BONTEMORGEN',
    'BOOMEN',
    'BOOMPJESDIJK',
    'BOONESCHANS',
    'BOORD',
    'BOORNBERGUM',
    'BOORNZWAAG',
    'BOORNZWAAG OVER DE WIELEN',
    'BORCULO',
    'BORGER',
    'BORGERCOMPAGNIE',
    'BORGERTANGE',
    'BORGERVELD',
    'BORGHAREN',
    'BORGSWEER',
    'BORGWEG',
    'BORKEL',
    'BORKELD',
    'BORN',
    'BORNE',
    'BORNEO',
    'BORNERBROEK',
    'BORNWIRD',
    'BORNWIRDHUIZEN',
    'BORSSELE',
    'BORTELDONK',
    'BOSCH',
    'BOSCH EN DUIN',
    'BOSCHEIND',
    'BOSCHHEURNE',
    'BOSCHHOVEN',
    'BOSCHKENS',
    'BOSCHOORD',
    'BOSHOEK',
    'BOSHOVEN',
    'BOSHUIZEN',
    'BOSJE',
    'BOSKAMP',
    'BOSKANT',
    'BOSKOOP',
    'BOSLUST',
    'BOSSCHENHOOFD',
    'BOSSCHENHUIZEN',
    'BOSSCHERHEIDE',
    'BOSSERSTRAAT',
    'BOSVEN',
    'BOTEBUREN',
    'BOTERVEEN',
    'BOTERWIJK',
    'BOTLEK',
    'BOTSHOOFD',
    'BOUCHAUTERHAVEN',
    'BOUDEWIJNSKERKE',
    'BOUKOUL',
    'BOURTANGE',
    'BOUWEKLEASTER',
    'BOUWERSCHAP',
    'BOVEN HAASTRECHT',
    'BOVEN HARDINXVELD',
    'BOVEN LEEUWEN',
    'BOVEN PEKELA',
    'BOVEN VEENSLOOT',
    'BOVENBERG',
    'BOVENEIND',
    'BOVENEINDE',
    'BOVENKARSPEL',
    'BOVENKERK',
    'BOVENRIJGE',
    'BOVENSLUIS',
    'BOVENSMILDE',
    'BOVENSTAD',
    'BOVENSTE HUIS',
    'BOVENSTEHUIS',
    'BOVENSTREEK',
    'BOXMEER',
    'BOXTEL',
    'BOYL',
    'BOZUM',
    'BRAAKHOEK',
    'BRAAMBERG',
    'BRAAMBOS CH',
    'BRAAMT',
    'BRABANDER',
    'BRAKEL',
    'BRAMMELO',
    'BRAND',
    'BRANDEMOLEN',
    'BRANDT',
    'BRANDWIJK',
    'BRANTGUM',
    'BREDA',
    'BREDELAAR',
    'BREDEVOORT',
    'BREEDE',
    'BREEDENBROEK',
    'BREEDEVEEN',
    'BREEDEWEG',
    'BREEDSCHOT',
    'BREEHEES',
    'BREEMORTEL',
    'BREEVELD',
    'BREEZAND',
    'BREEZANDDIJK',
    'BREKLENKAMP',
    'BREM',
    'BREMBOSCH',
    'BRESKENS',
    'BREUDIJK',
    'BREUGEL',
    'BREUKELEN',
    'BREUKELEVEEN',
    'BREYVIN',
    'BRIELLE',
    'BRIGDAMME',
    'BRIJDORPE',
    'BRILLERIJ',
    'BRILTIL',
    'BRINKMANSHOEK',
    'BRITSUM',
    'BRITSWERD',
    'BRITSWERT',
    'BROEK',
    'BROEK IN WATERLAND',
    'BROEK OP LANGEDIJK',
    'BROEKEIND',
    'BROEKENSEIND',
    'BROEKHEURNE',
    'BROEKHOVEN',
    'BROEKHUIZEN',
    'BROEKHUIZENVORST',
    'BROEKKANT',
    'BROEKLAND',
    'BROEKSTERWALD',
    'BROEKSTERWOUDE',
    'BROEKSTERWÂLD',
    'BROEKZIJDE',
    'BROERDIJK',
    'BROMMELEN',
    'BRONKHORST',
    'BRONNEGER',
    'BRONNEGERVEEN',
    'BRONSVEEN',
    'BROUWERSHAVEN',
    'BRUCHEM',
    'BRUCHT',
    'BRUCHTERVELD',
    'BRUGGEN',
    'BRUGGERHUIZEN',
    'BRUINEHAAR',
    'BRUINISSE',
    'BRUISTERBOSCH',
    'BRUMHOLD',
    'BRUMMEN',
    'BRUNSSUM',
    'BRUNSTING',
    'BRUNTINGE',
    'BUCHTEN',
    'BUDEL',
    'BUDEL DORPLEIN',
    'BUDEL SCHOOT',
    'BUEREN',
    'BUGGENUM',
    'BUINEN',
    'BUINERVEEN',
    'BUITENHUIZEN',
    'BUITENKAAG',
    'BUITENPOST',
    'BUITENSTVERLAAT',
    'BULKEMSBROEK',
    'BULKENAAR',
    'BULLENKAMP',
    'BULTINGE',
    'BUNDE',
    'BUNNE',
    'BUNNIK',
    'BUNSCHOTEN SPAKENBURG',
    'BURCHWERT',
    'BURDAARD',
    'BUREN',
    'BURGEMEESTER BEINSDORP',
    'BURGERBRUG',
    'BURGERSDIJK',
    'BURGERVEEN',
    'BURGERVLOTBRUG',
    'BURGH',
    'BURGH HAAMSTEDE',
    'BURGHSLUIS',
    'BURGT',
    'BURGUM',
    'BURGWERD',
    'BURSTUM',
    'BURUM',
    'BUS',
    'BUSSEL',
    'BUSSELTE',
    'BUSSEREIND',
    'BUSSLOO',
    'BUSSUM',
    'BUTENPOST',
    'BUTENSTFALLAAT',
    'BUTTINGA',
    'BUTTINGE',
    'BUURMALSEN',
    'BUURSE',
    'BUURTJE',
    'BUWEKLOOSTER',
    'BÛTENPOST',
    'BÛTENSTFALLAAT',
    'CABAUW',
    'CADIER EN KEER',
    'CADZAND',
    'CADZAND BAD',
    'CALFVEN',
    'CALIFORNIE',
    'CALIFORNIË',
    'CALLANTSOOG',
    'CALSLAGEN',
    'CALUNA',
    'CAMERIG',
    'CAPELLE',
    'CAPELLE AAN DEN IJSSEL',
    'CAPELLE WEST',
    'CARNISSE',
    'CARTILS',
    'CASTELRE',
    'CASTELRÉ',
    'CASTENRAY',
    'CASTEREN',
    'CASTERT',
    'CASTRICUM',
    'CATSOP',
    'CATTENBROEK',
    'CAUWELAER',
    'CELLEMUIDEN',
    'CERESDORP',
    'CHAAM',
    'CHAAMDIJK',
    'CLINGE',
    'COEVORDEN',
    'COLDENHOVE',
    'COLIJNSPLAAT',
    'COLLENDOORN',
    'COLLENDOORNERVEEN',
    'COLMONT',
    'COLMSCHATE',
    'COMMISSIEPOLLE',
    'CORNJUM',
    'CORNWERD',
    'CORTENOEVER',
    'COTHEN',
    'COTTESSEN',
    'COUWELAAR',
    'CRAILO',
    'CRANENDONCK',
    'CRAPOEL',
    'CRAUBEEK',
    'CREIL',
    'CREVECOEUR',
    'CRIXHOEK',
    'CROB',
    'CROMVOIRT',
    'CROY',
    'CRUQUIUS',
    'CRÈVECOEUR',
    'CUIJK',
    'CULEMBORG',
    'DAARLE',
    'DAARLERVEEN',
    'DAL',
    'DALAND',
    'DALE',
    'DALEM',
    'DALEN',
    'DALEREND',
    'DALERPEEL',
    'DALERVEEN',
    'DALFSEN',
    'DALLINGEWEER',
    'DALMSHOLTE',
    'DAM',
    'DAMWALD',
    'DAMWOUDE',
    'DAMWÂLD',
    'DANIKEN',
    'DARP',
    'DARTHUIZEN',
    'DASSEMUS',
    'DE AA',
    'DE BAAN',
    'DE BARGEBEK',
    'DE BEEK',
    'DE BELT',
    'DE BENTE',
    'DE BERG',
    'DE BERK',
    'DE BERKEN',
    'DE BIEZEN',
    'DE BILT',
    'DE BIRKT',
    'DE BLESSE',
    'DE BLIJNSE',
    'DE BLOKKEN',
    'DE BOBERDEN',
    'DE BOCHT',
    'DE BOER',
    'DE BOLT',
    'DE BOSJES',
    'DE BREE',
    'DE BROEK BROEK NOORD',
    'DE BRUIL',
    'DE BUIS',
    'DE BULT',
    'DE BUS',
    'DE BUURT',
    'DE COCKSDORP',
    'DE DELLEN',
    'DE DINGEN',
    'DE DONK',
    'DE DOOD',
    'DE DRACHTSTER KOMPENIJE',
    'DE DRIESPRONG',
    'DE DRUIF',
    'DE ELFT',
    'DE ENG',
    'DE ENGEL',
    'DE FALOM',
    'DE FEANHOOP',
    'DE FOCHTEL',
    'DE GAASTEN',
    'DE GAASTMAR',
    'DE GAGEL',
    'DE GALHOEK',
    'DE GINKEL',
    'DE GLIND',
    'DE GOORN',
    'DE GORDYK',
    'DE GRACHT',
    'DE GRITS',
    'DE GROE',
    'DE GROEP',
    'DE GROEVE',
    'DE HAANDRIK',
    'DE HAAR',
    'DE HAERE',
    'DE HARKEMA',
    'DE HASPEL',
    'DE HAULE',
    'DE HEEN',
    'DE HEES',
    'DE HEIBERG',
    'DE HEIDE',
    'DE HEL',
    'DE HEM',
    'DE HEUL',
    'DE HEURNE',
    'DE HEUVEL',
    'DE HEUVELS',
    'DE HILTE',
    'DE HIM',
    'DE HIMRIK',
    'DE HOEF',
    'DE HOEK',
    'DE HOEVE',
    'DE HOEVEN',
    'DE HOGERT',
    'DE HOLM',
    'DE HOMMERTS',
    'DE HOOGE WEGEN',
    'DE HORCK',
    'DE HORST',
    'DE HOUTIGEHAGE',
    'DE HOUW',
    'DE HUT',
    'DE HUTTEN',
    'DE JAMMER',
    'DE JOUWER',
    'DE KADE',
    'DE KAPEL',
    'DE KAR',
    'DE KEEGEN',
    'DE KEMPKENS',
    'DE KIEL',
    'DE KIEVIT',
    'DE KLEI',
    'DE KLEM',
    'DE KLOMP',
    'DE KLOSSE',
    'DE KNIPE',
    'DE KNOL',
    'DE KNOLLE',
    'DE KOLK',
    'DE KOLONIE',
    'DE KOOG',
    'DE KOOI',
    'DE KRAAN',
    'DE KRAATS',
    'DE KRIM',
    'DE KROSSELT',
    'DE KWAKEL',
    'DE LAAN',
    'DE LANGELILLE',
    'DE LANGSTRAAT',
    'DE LAREN',
    'DE LEIJEN',
    'DE LEMMER',
    'DE LENT',
    'DE LETHE',
    'DE LEUKE',
    'DE LIER',
    'DE LOGT',
    'DE LOO',
    'DE LOOFAERT',
    'DE LOOI',
    'DE LUTTE',
    'DE LYTSE GAASTMAR',
    'DE LYTSE JOUWER',
    'DE MAAT',
    'DE MARS',
    'DE MARSHOEK',
    'DE MATEN',
    'DE MEELE',
    'DE MEENE',
    'DE MEERN',
    'DE MOER',
    'DE MORTEL',
    'DE MUIS',
    'DE MULDERIJ',
    'DE MUNTE',
    'DE NACHTEGAAL',
    'DE NIEUWE HOEVEN',
    'DE OVERVAL',
    'DE PAAUWEN',
    'DE PAN',
    'DE PAS',
    'DE PEIN',
    'DE PLAATS',
    'DE POFFERT',
    'DE POL',
    'DE POLLE',
    'DE POLLEN',
    'DE POMP',
    'DE POSTHOORN',
    'DE PUNT',
    'DE RAND',
    'DE RATTE',
    'DE RIETSCHOOF',
    'DE RIJLST',
    'DE RIJP',
    'DE RIJTJES',
    'DE RIPS',
    'DE ROSKAM',
    'DE ROTTE',
    'DE ROTTING',
    'DE RUIF',
    'DE RUIGEWAARD',
    'DE RUND',
    'DE RYP',
    'DE SCHANS',
    'DE SCHATKUIL',
    'DE SCHIETBAAN',
    'DE SCHIFPOT',
    'DE SCHIPHORST',
    'DE SCHOOLT',
    'DE SCHUTTERIJ',
    'DE SKANS',
    'DE SKÂNS',
    'DE SLUIS',
    'DE SNIPPERIJ',
    'DE STAPEL',
    'DE STEEG',
    'DE STEEGH',
    'DE STERRE',
    'DE STREEK',
    'DE STUW',
    'DE TIBBEN',
    'DE TIKE',
    'DE TIPPE',
    'DE TRIEME',
    'DE TUUT',
    'DE TYNJE',
    'DE ULESPRONG',
    'DE VAL',
    'DE VALK',
    'DE VALOM',
    'DE VECHT',
    'DE VEENHOOP',
    'DE VEENHUIS',
    'DE VELDE',
    'DE VLEUT',
    'DE VOORSTAD',
    'DE VOORT',
    'DE VORST',
    'DE WAAL',
    'DE WEEL',
    'DE WEERD',
    'DE WEERE',
    'DE WEIJER',
    'DE WEPER',
    'DE WIELSE HOEVEN',
    'DE WIGEAST OF WYGEAST',
    'DE WIJK',
    'DE WILGEN',
    'DE WILP',
    'DE WIPPERT',
    'DE WOLFSPUTTEN',
    'DE WOPEREIS',
    'DE WOUDE',
    'DE WYLGEN',
    'DE ZAK',
    'DE ZANDE',
    'DE ZANDPUT',
    'DE ZILK',
    'DEARSUM',
    'DEDEMSVAART',
    'DEDGUM',
    'DEDZJUM',
    'DEELEN',
    'DEELSE KAMPEN',
    'DEELSHURK',
    'DEENSE HOEK',
    'DEEST',
    'DEIL',
    'DEINUM',
    'DEKESHORST',
    'DEKKERSHUIZEN',
    'DELBUORREN',
    'DELBUREN',
    'DELDEN',
    'DELDENERBROEK',
    'DELDENERESCH',
    'DELFGAUW',
    'DELFSTRAHUIZEN',
    'DELFT',
    'DELFZIJL',
    'DELWIJNEN',
    'DEMEN',
    'DEMMERIK',
    'DEN AKKER',
    'DEN ANDEL',
    'DEN BERG',
    'DEN BOMMEL',
    'DEN BRAAM',
    'DEN BROEK',
    'DEN BURG',
    'DEN DEIJL',
    'DEN DOLDER',
    'DEN DOOL',
    'DEN DUNGEN',
    'DEN HAAG',
    'DEN HAM',
    'DEN HELDER',
    'DEN HOEF',
    'DEN HOEK',
    'DEN HOOL',
    'DEN HOORN',
    'DEN HORN',
    'DEN HOUT',
    'DEN HUIZEN',
    'DEN HULST',
    'DEN ILP',
    'DEN KAAT',
    'DEN NUL',
    'DEN OEVER',
    'DEN OORD',
    'DEN OOSTERHUIS',
    'DEN OPSLAG',
    'DEN TREEK',
    'DEN VELDE',
    'DEN WESTERHUIS',
    'DENEKAMP',
    'DENEMARKEN',
    'DEURNE',
    'DEURNINGEN',
    'DEURSEN DENNENBURG',
    'DEURZE',
    'DEUTEREN',
    'DEVENTER',
    'DIDAM',
    'DIEDEN',
    'DIEFDIJK',
    'DIEKENDAAL',
    'DIEMEN',
    'DIEMERBROEK',
    'DIEPENBROEK',
    'DIEPENDAL',
    'DIEPENHEIM',
    'DIEPENVEEN',
    'DIEPSWAL',
    'DIEREN',
    'DIERMEN',
    'DIESKANT',
    'DIESSEN',
    'DIETEREN',
    'DIEVER',
    'DIEVERBRUG',
    'DIFFELEN',
    'DIJK',
    'DIJKEN',
    'DIJKERHOEK',
    'DIJKERSTRAAT',
    'DIJKHOEK',
    'DIJKHUISJES',
    'DIJKHUIZEN',
    'DIJKSHORNE',
    'DIJKSTERBUREN',
    'DIJKWEL',
    'DIKBROEKEN',
    'DIKEN',
    'DINTELOORD',
    'DINTELSAS',
    'DINTHER',
    'DINTHERSE HOEK',
    'DINXPERLO',
    'DIPHOORN',
    'DIRKSHORN',
    'DIRKSLAND',
    'DISHOEK',
    'DISTELBERG',
    'DIUNT',
    'DOAIUM',
    'DOANJUM',
    'DODEWAARD',
    'DOENRADE',
    'DOESBURG',
    'DOESBURGERBUURT',
    'DOETINCHEM',
    'DOEVEREN',
    'DOEZUM',
    'DOIJUM',
    'DOKKUM',
    'DOKKUMER NIEUWE ZIJLEN',
    'DOKKUMER NIJE SILEN',
    'DOLBERG',
    'DOLDERSUM',
    'DOMBURG',
    'DOMME AANLEG',
    'DOMMELEN',
    'DOMMELSVOORT',
    'DOMWIER',
    'DONDEREN',
    'DONGEN',
    'DONGJUM',
    'DONIABUREN',
    'DONIAGA',
    'DONK',
    'DONKERBROEK',
    'DONKEREIND',
    'DONKERSVOORT',
    'DONZEL',
    'DOODSTIL',
    'DOONHEIDE',
    'DOORN',
    'DOORNENBURG',
    'DOORNHOEK',
    'DOORNIK',
    'DOORNING',
    'DOORNSPIJK',
    'DOORNSTEEG',
    'DOORWERTH',
    'DOOSJE',
    'DORDRECHT',
    'DORKWERD',
    'DORP',
    'DORSHOUT',
    'DORST',
    'DORTHERHOEK',
    'DOUVERGENHOUT',
    'DOUWEN',
    'DRAAIBRUG',
    'DRAAISTERHUIZEN',
    'DRACHTEN',
    'DRACHTEN AZEVEN',
    'DRACHTSTERCOMPAGNIE',
    'DRAEISTERHUZEN',
    'DREISCHOR',
    'DREMPT',
    'DREUMEL',
    'DRIE',
    'DRIE HOEFIJZERS',
    'DRIEBERGEN RIJSENBURG',
    'DRIEBOEREHUIZEN',
    'DRIEBORG',
    'DRIEBRUGGEN',
    'DRIEDORP',
    'DRIEENHUIZEN',
    'DRIEHOEK',
    'DRIEHUIS',
    'DRIEHUIZEN',
    'DRIEL',
    'DRIEMOND',
    'DRIENE',
    'DRIES',
    'DRIESCHOUWEN',
    'DRIESPRONG',
    'DRIESUM',
    'DRIEWEGEN',
    'DRIEZUM',
    'DRIEËNHUIZEN',
    'DRIJBER',
    'DRIMMELEN',
    'DROEGEHAM',
    'DROGEHAM',
    'DROGT',
    'DROGTEROPSLAGEN',
    'DRONGELEN',
    'DRONRIJP',
    'DRONRYP',
    'DRONTEN',
    'DROUWEN',
    'DROUWENERMOND',
    'DROUWENERVEEN',
    'DRUISDIJK',
    'DRUNEN',
    'DRUTEN',
    'DRYLTS',
    'DUBBROEK',
    'DUIFHUIS',
    'DUIKSEHOEF',
    'DUINEN',
    'DUISTERVOORDE',
    'DUIVEN',
    'DUIVENDRECHT',
    'DUIVENHOEK',
    'DUIZEL',
    'DUIZEND MORGEN',
    'DULDER',
    'DUN',
    'DUNEGEA',
    'DUNSBORG',
    'DURGERDAM',
    'DUSSEN',
    'DUUR',
    'DUURENDSEIND',
    'DUURKENAKKER',
    'DWARSDIEP',
    'DWARSDIJK',
    'DWARSGRACHT',
    'DWINGELOO',
    'DYKSHOARNE',
    'DYKSTERBUORREN',
    'EAGMARYP',
    'EAGUM',
    'EALAHUZEN',
    'EALAHÚZEN',
    'EALSUM',
    'EANJUM',
    'EARNEWALD',
    'EARNEWÂLD',
    'EAST FLYLAN',
    'EAST FLYLÂN',
    'EASTERBIERRUM',
    'EASTERBOARN',
    'EASTEREIN',
    'EASTERLITTENS',
    'EASTERMAR',
    'EASTERNIJTSJERK',
    'EASTERSEE',
    'EASTERSEE BUORREN',
    'EASTERWALDE',
    'EASTERWIERRUM',
    'EASTERWÂLDE',
    'EASTHIM',
    'EASTRUM',
    'EBBENBROEK',
    'ECHT',
    'ECHTELD',
    'ECHTEN',
    'ECHTENERBRUG',
    'ECHTERBOSCH',
    'ECK EN WIEL',
    'ECKELRADE',
    'EDAM',
    'EDE',
    'EDENS',
    'EDERVEEN',
    'EEDE',
    'EEFDE',
    'EEFSELE',
    'EEKT',
    'EEKWERD',
    'EEKWERDERDRAAI',
    'EELDE',
    'EELDE PATERSWOLDE',
    'EELDERWOLDE',
    'EELEN',
    'EEMBRUGGE',
    'EEMDIJK',
    'EEMNES',
    'EEMSHAVEN',
    'EEMSTER',
    'EEMSWOUDE',
    'EEMTEN',
    'EEN',
    'EEN WEST',
    'EENEIND',
    'EENIGENBURG',
    'EENRUM',
    'EENUM',
    'EERBEEK',
    'EERDE',
    'EERNEWOUDE',
    'EERSEL',
    'EERSTE DWARSDIEP',
    'EES',
    'EESE',
    'EESERGROEN',
    'EESERVEEN',
    'EESTERGA',
    'EESTRUM',
    'EESVEEN',
    'EETHEN',
    'EEXT',
    'EEXTAHAVEN',
    'EEXTERVEEN',
    'EEXTERVEENSCHEKANAAL',
    'EEXTERZANDVOORT',
    'EFFEN',
    'EGBERTSGAASTEN',
    'EGCHEL',
    'EGCHELHEIDE',
    'EGEDE',
    'EGMOND AAN DEN HOEF',
    'EGMOND AAN ZEE',
    'EGMOND BINNEN',
    'EGYPTE',
    'EIBERGEN',
    'EIJSDEN',
    'EIKBERG',
    'EIKELENBOSCH',
    'EIKELHOF',
    'EIKENHEUVEL',
    'EILAND',
    'EIMEREN',
    'EIND',
    'EIND VAN DEN HOUT',
    'EINDE',
    'EINDEWEGE',
    'EINDHOVEN',
    'EINDJE',
    'EINIGHAUSEN',
    'EKAMP',
    'EKEHAAR',
    'EKSMOARRE',
    'EKSMOARRESYL',
    'ELAHUIZEN',
    'ELBURG',
    'ELDE',
    'ELDERSLOO',
    'ELDIK',
    'ELDRIK',
    'ELEVELD',
    'ELIM',
    'ELKENRADE',
    'ELKERZEE',
    'ELL',
    'ELLECOM',
    'ELLEMEET',
    'ELLERHEI',
    'ELLERHUIZEN',
    'ELLERSINGHUIZEN',
    'ELLERTSHAAR',
    'ELLEWOUTSDIJK',
    'ELP',
    'ELSEN',
    'ELSENDORP',
    'ELSENERBROEK',
    'ELSHOF',
    'ELSHOUT',
    'ELSLO',
    'ELSLOO',
    'ELSPEET',
    'ELST',
    'ELSTEREN',
    'ELZET',
    'EMMABERG',
    'EMMADORP',
    'EMMELOORD',
    'EMMEN',
    'EMMER COMPASCUUM',
    'EMMINKHUIZEN',
    'EMPE',
    'EMPEL',
    'EMST',
    'ENDEPOEL',
    'ENG',
    'ENGBERGEN',
    'ENGELAND',
    'ENGELBERT',
    'ENGELEN',
    'ENGELUM',
    'ENGLUM',
    'ENGWEGEN',
    'ENGWERD',
    'ENGWIER',
    'ENGWIERUM',
    'ENKHUIZEN',
    'ENS',
    'ENSCHEDE',
    'ENSPIJK',
    'ENTER',
    'ENUMATIL',
    'ENZELENS',
    'EPE',
    'EPEN',
    'EPERHEIDE',
    'EPPENHUIZEN',
    'EPPENZOLDER',
    'EPSE',
    'ERICA',
    'ERICHEM',
    'ERLECOM',
    'ERM',
    'ERMELO',
    'ERMERVEEN',
    'ERP',
    'ESBEEK',
    'ESCH',
    'ESCHAREN',
    'ESCHOTEN',
    'ESDONK',
    'ESP',
    'ESPEL',
    'ESPELO',
    'ESSEBROEK',
    'ESSEN',
    'EST',
    'ESVELD',
    'ETENAKEN',
    'ETSBERG',
    'ETTEN',
    'ETTEN LEUR',
    'ETZENRADE',
    'EUROPOORT',
    'EURSING',
    'EURSINGE',
    'EUVELWEGEN',
    'EUVEREM',
    'EVENHEUVEL',
    'EVERDINGEN',
    'EVERLAND',
    'EVERLO',
    'EVERSDIJK',
    'EVERSE',
    'EVERTSOORD',
    'EWER',
    'EWIJK',
    'EWINKEL',
    'EXEL',
    'EXEL TOL',
    'EXLOERKIJL',
    'EXLOERVEEN',
    'EXLOO',
    'EXLOËRKIJL',
    'EXLOËRVEEN',
    'EXMORRA',
    'EXMORRAZIJL',
    'EYGELSHOVEN',
    'EYS',
    'EYSERHEIDE',
    'EZINGE',
    'EZUMAZIJL',
    'FAAN',
    'FAREBUORREN',
    'FARMSUM',
    'FATUM',
    'FEANKLEASTER',
    'FEANWALDEN',
    'FEANWALDSTERWAL',
    'FEANWÂLDEN',
    'FEANWÂLDSTERWÂL',
    'FEERWERD',
    'FEINSUM',
    'FELLAND',
    'FENEKOATEN',
    'FERWALDE',
    'FERWERD',
    'FERWERT',
    'FERWOUDE',
    'FERWÂLDE',
    'FEYTEBUORREN',
    'FIEMEL',
    'FIIFHUZEN',
    'FIJFHUS',
    'FIJFHÛS',
    'FIJNAART',
    'FINKEBUORREN',
    'FINKEBUREN',
    'FINKEGEA',
    'FINKUM',
    'FINSTERWOLDE',
    'FINSTERWOLDERHAMRIK',
    'FIRDGUM',
    'FISKBUORREN',
    'FISKERSBUORREN',
    'FJOUWERHUS',
    'FJOUWERHÛS',
    'FLANSUM',
    'FLERINGEN',
    'FLIEREN',
    'FLUITENBERG',
    'FLYLAN',
    'FLYLÂN',
    'FLÂNSUM',
    'FOARRYP',
    'FOCHTELOO',
    'FOKKERSHOEK',
    'FOLLEGA',
    'FOLLEGEA',
    'FOLSGARE',
    'FOLSGEARE',
    'FONS',
    'FORMEARUM',
    'FORMERUM',
    'FORT',
    'FORTMOND',
    'FOUDGUM',
    'FOXHOL',
    'FOXHOLSTERBOSCH',
    'FOXWOLDE',
    'FRAAMKLAP',
    'FRANEKER',
    'FRANSCHEHOEF',
    'FRANSE HOEF',
    'FRANSUM',
    'FREDERIKSOORD',
    'FRIENS',
    'FRIESCHEPALEN',
    'FRIESLAND',
    'FRIESWIJK',
    'FRJENTSJER',
    'FROMBERG',
    'FROOMBOSCH',
    'FROUBUORREN',
    'FRYSKE PEALLEN',
    'FRYTUM',
    'FUNS',
    'FURDGUM',
    'FÛNS',
    'GAAG',
    'GAANDEREN',
    'GAARKEUKEN',
    'GAARLAND',
    'GAAST',
    'GAASTMEER',
    'GAETE',
    'GALAMADAMMEN',
    'GALDER',
    'GALHOEKE',
    'GAMEREN',
    'GAMMELKE',
    'GANZEDIJK',
    'GANZERT',
    'GAPINGE',
    'GARDERBROEK',
    'GARDEREN',
    'GARIJP',
    'GARMERWOLDE',
    'GARMINGE',
    'GARNWERD',
    'GARRELSWEER',
    'GARREWEER',
    'GARSTHUIZEN',
    'GARYP',
    'GASSEL',
    'GASSELTE',
    'GASSELTERBOERVEEN',
    'GASSELTERBOERVEENSCHEMOND',
    'GASSELTERNIJVEEN',
    'GASSELTERNIJVEENSCHEMOND',
    'GASTEL',
    'GASTELSVEER',
    'GASTEREN',
    'GASTHUIS',
    'GAU',
    'GAUW',
    'GAWEGE',
    'GEBERGTE',
    'GEBROEK',
    'GEEFSWEER',
    'GEELBROEK',
    'GEENEIND',
    'GEER',
    'GEERDIJK',
    'GEERSBROEK',
    'GEERSDIJK',
    'GEERSTRAAT',
    'GEERTRUIDENBERG',
    'GEERVLIET',
    'GEES',
    'GEESBRUG',
    'GEESTDORP',
    'GEESTEREN',
    'GEEUWENBRUG',
    'GEFFEN',
    'GEIJSTEREN',
    'GEITENWAARD',
    'GELDERMALSEN',
    'GELDERSE BUURT',
    'GELDERSWOUDE',
    'GELDROP',
    'GELDTIENDEN',
    'GELEEN',
    'GELKENES',
    'GELLICUM',
    'GELOO',
    'GELSELAAR',
    'GEMAAL',
    'GEMENT',
    'GEMERT',
    'GEMONDE',
    'GENDEREN',
    'GENDIJK',
    'GENDRINGEN',
    'GENDT',
    'GENEIJGEN',
    'GENEMUIDEN',
    'GENENEIND',
    'GENING',
    'GENNE',
    'GENNE OVERWATERS',
    'GENNEP',
    'GENOENHUIS',
    'GENOOI',
    'GENUM',
    'GERHEGGEN',
    'GERKESKLEASTER',
    'GERKESKLOOSTER',
    'GERNER',
    'GERSLEAT',
    'GERSLOOT',
    'GERVEN',
    'GERVERSCOP',
    'GERWEN',
    'GEULHEM',
    'GEULLE',
    'GEULLE AAN DE MAAS',
    'GEVER',
    'GEVERIK',
    'GEWANDE',
    'GIEKERK',
    'GIEKERKERHOEK',
    'GIELTJESDORP',
    'GIERSBERGEN',
    'GIESBEEK',
    'GIESSEN',
    'GIESSEN OUDEKERK',
    'GIESSENBURG',
    'GIESSENDAM',
    'GIETELO',
    'GIETEN',
    'GIETERVEEN',
    'GIETERZANDVOORT',
    'GIETHMEN',
    'GIETHOORN',
    'GIJBELAND',
    'GIJSSELTE',
    'GIJZEL',
    'GIJZENROOI',
    'GILZE',
    'GINDERDOOR',
    'GINNUM',
    'GLANE',
    'GLANE BEEKHOEK',
    'GLANERBRUG',
    'GLIMMEN',
    'GOAIINGARYP',
    'GOAIINGEA',
    'GOAIJINGAHUZEN',
    'GOAIÏNGARYP',
    'GOAIÏNGEA',
    'GODLINZE',
    'GOEDEREEDE',
    'GOENGA',
    'GOENGAHUIZEN',
    'GOES',
    'GOIDSCHALXOORD',
    'GOILBERDINGEN',
    'GOINGARIJP',
    'GOIRLE',
    'GOLDHOORN',
    'GOOIUM',
    'GOOR',
    'GORINCHEM',
    'GORPEIND',
    'GORREDIJK',
    'GORSSEL',
    'GORTEL',
    'GOUDA',
    'GOUDEN PLOEG',
    'GOUDERAK',
    'GOUDRIAAN',
    'GOUDSEWEG',
    'GOUDSWAARD',
    'GOUTUM',
    'GOËNGA',
    'GOËNGAHUIZEN',
    'GRAAF',
    'GRAAFLAND',
    'GRAAUW',
    'GRACHT',
    'GRACHT BURGGRAAF',
    'GRAETHEIDE',
    'GRAFHORST',
    'GRAFT',
    'GRAFWEGEN',
    'GRAMSBERGEN',
    'GRASHOEK',
    'GRASPEEL',
    'GRASWIJK',
    'GRASZODE',
    'GRATHEM',
    'GRAUWE KAT',
    'GRAVE',
    'GRAZEN',
    'GREFFELING',
    'GREFFELKAMP',
    'GREONTERP',
    'GREUP',
    'GREVENBERG',
    'GREVENBICHT',
    'GRIENDTSVEEN',
    'GRIETE',
    'GRIJPSKERK',
    'GRIJPSKERKE',
    'GRIJSSLOOT',
    'GRIJZEGRUBBEN',
    'GROEDE',
    'GROENEKAN',
    'GROENENDAAL',
    'GROENENDIJK',
    'GROENEWEG',
    'GROENEWOUD',
    'GROENINGEN',
    'GROENLANDEN',
    'GROENLANDSEKADE',
    'GROENLO',
    'GROENSTRAAT',
    'GROENVELD',
    'GROESBEEK',
    'GROESSEN',
    'GROET',
    'GROEZE',
    'GROLLOO',
    'GRONINGEN',
    'GRONSVELD',
    'GROOT ABEELE',
    'GROOT AGELO',
    'GROOT AMMERS',
    'GROOT BEDAF',
    'GROOT BRUGGEN',
    'GROOT DEUNK',
    'GROOT DOCHTEREN',
    'GROOT GENHOUT',
    'GROOT HAASDAL',
    'GROOT HITLAND',
    'GROOT LOO',
    'GROOT MAARSLAG',
    'GROOT MEDHUIZEN MIDHUIZEN',
    'GROOT OEVER',
    'GROOT VALKENISSE',
    'GROOT WELSDEN',
    'GROOT WETSINGE',
    'GROOTE BOTTEL',
    'GROOTE HOEVEN',
    'GROOTE HORST',
    'GROOTE KEETEN',
    'GROOTEBROEK',
    'GROOTEGAST',
    'GROOTSCHERMER',
    'GROOTWIJNGAARDEN',
    'GROTE VOORT',
    'GROTE WISKE',
    'GROTEL',
    'GROU',
    'GROUW',
    'GRUBBENVORST',
    'GRUT MIDHUZEN',
    'GULPEN',
    'GUN',
    'GUTTECOVEN',
    'GYTSJERK',
    'GYTSJERKSTERHOEKE',
    'HAAFTEN',
    'HAAG',
    'HAAGJE',
    'HAAKSBERGEN',
    'HAAKSWOLD',
    'HAALDEREN',
    'HAALWEIDE',
    'HAAMSTEDE',
    'HAANWIJK',
    'HAAREN',
    'HAARLE',
    'HAARLEM',
    'HAARLEMMERLIEDE',
    'HAARLO',
    'HAARSTEEG',
    'HAART',
    'HAARZUILENS',
    'HAASDAL',
    'HAASTRECHT',
    'HAELEN',
    'HAELENSCHE BROEK',
    'HAERST',
    'HAGESTEIN',
    'HAGHORST',
    'HAIINK',
    'HAL',
    'HALDER',
    'HALER',
    'HALFEIND',
    'HALFMIJL',
    'HALFWEG',
    'HALL',
    'HALLE',
    'HALLE HEIDE',
    'HALLE NIJMAN',
    'HALLERHOEK',
    'HALLUM',
    'HALLUMERHOEK',
    'HALLUMERHOEKE',
    'HALSTEREN',
    'HALTE',
    'HALVINKHUIZEN',
    'HAM',
    'HAMDIJK',
    'HAMINGEN',
    'HAMMELSBERG',
    'HAMRIK',
    'HAMSHERNE',
    'HAMSHORN',
    'HANDEL',
    'HANEBUREN',
    'HANENBERG',
    'HANENDORP',
    'HANK',
    'HANKATE',
    'HANSWEERT',
    'HANTUM',
    'HANTUMERHOEK',
    'HANTUMERHOEKE',
    'HANTUMERUITBUREN',
    'HANTUMERUTBUORREN',
    'HANTUMERÚTBUORREN',
    'HANTUMHUIZEN',
    'HANTUMHUZEN',
    'HAPERT',
    'HAPS',
    'HARBRINKHOEK',
    'HARCULO',
    'HARDEGARIJP',
    'HARDENBERG',
    'HARDERWIJK',
    'HARDEWEER',
    'HARDINXVELD GIESSENDAM',
    'HAREN',
    'HARENDERMOLEN',
    'HARENERMOLEN',
    'HARFSEN',
    'HARICH',
    'HARICH WESTEREND',
    'HARING',
    'HARINGHUIZEN',
    'HARKEMA',
    'HARKEZIJL',
    'HARKSTEDE',
    'HARLES',
    'HARLINGEN',
    'HARMELEN',
    'HARMELERWAARD',
    'HARMOLE',
    'HARMÖLE',
    'HARNS',
    'HARPEL',
    'HARREVELD',
    'HARSELAAR',
    'HARSKAMP',
    'HARSSENS',
    'HARTWERD',
    'HARTWERT',
    'HASJESSTRAAT',
    'HASKERDIJKEN',
    'HASKERDIKEN',
    'HASKERHOARNE',
    'HASKERHORNE',
    'HASPEL',
    'HASSELT',
    'HASSELTERHEIDE',
    'HATTELAAR',
    'HATTEM',
    'HATTEMERBROEK',
    'HAULE',
    'HAULERWIJK',
    'HAULERWYK',
    'HAUWERT',
    'HAVELT',
    'HAVELTE',
    'HAVELTERBERG',
    'HAVENHOOFD',
    'HAYUM',
    'HAZELAAR',
    'HAZELBERG',
    'HAZELDONK',
    'HAZENHURK',
    'HAZENNEST',
    'HAZERSWOUDE DORP',
    'HAZERSWOUDE RIJNDIJK',
    'HEABURGEN',
    'HEBRECHT',
    'HEDEL',
    'HEDIKHUIZEN',
    'HEE',
    'HEECH',
    'HEECH DUERSWALD',
    'HEECH DUERSWÂLD',
    'HEEG',
    'HEEGHERHOEK',
    'HEEK',
    'HEEL',
    'HEELSUM',
    'HEELWEG',
    'HEELWEG OOST',
    'HEELWEG WEST',
    'HEEMSERVEEN',
    'HEEMSKERK',
    'HEEMSTEDE',
    'HEENSCHE MOLEN',
    'HEENVLIET',
    'HEENWEG',
    'HEERDE',
    'HEEREBUREN',
    'HEEREIND',
    'HEERENDONK',
    'HEERENVEEN',
    'HEEREWAARDEN',
    'HEERHUGOWAARD',
    'HEERJANSDAM',
    'HEERLE',
    'HEERLEN',
    'HEERS',
    'HEERSTAAIEN',
    'HEERSTRAAT',
    'HEES',
    'HEESAKKER',
    'HEESBEEN',
    'HEESBOOM',
    'HEESCH',
    'HEESEIND',
    'HEESSELT',
    'HEESWIJK',
    'HEESWIJK DINTHER',
    'HEETEN',
    'HEETVELD',
    'HEEZE',
    'HEEZERENBOSCH',
    'HEFSWAL',
    'HEGEBEINTUM',
    'HEGELSOM',
    'HEGGE',
    'HEI',
    'HEI EN BOEICOP',
    'HEI OOSTENRIJK',
    'HEIAKKER',
    'HEIBLOEM',
    'HEIDE',
    'HEIDEHUIZEN',
    'HEIDEKANT',
    'HEIDENHOEK',
    'HEIDERSCHOOR',
    'HEIDVELD',
    'HEIEIND',
    'HEIEREIND',
    'HEIERHOEVE',
    'HEIHOEFKE',
    'HEIHOEK',
    'HEIJBEEK',
    'HEIJEN',
    'HEIJENRATH',
    'HEIJNINGEN',
    'HEIKANT',
    'HEIKANTSE HOEVE',
    'HEILIG LANDSTICHTING',
    'HEILIGEBOOM',
    'HEILIGERLEE',
    'HEILLE',
    'HEILOO',
    'HEIMOLEN',
    'HEINEBUREN',
    'HEINENOORD',
    'HEINKENSZAND',
    'HEINO',
    'HEIOORD',
    'HEISCHE WAL',
    'HEISTERBRUG',
    'HEISTRAAT',
    'HEITRAK',
    'HEIVELD',
    'HEKELINGEN',
    'HEKENDORP',
    'HEKKUM',
    'HELBROEK',
    'HELDEN',
    'HELDENSEDIJK',
    'HELENAVEEN',
    'HELHOEK',
    'HELHUIZEN',
    'HELKANT',
    'HELL',
    'HELLE',
    'HELLEBROEK',
    'HELLEGAT',
    'HELLENDOORN',
    'HELLENEIND',
    'HELLEVOETSLUIS',
    'HELLING',
    'HELLOUW',
    'HELLUM',
    'HELMOND',
    'HELSDINGEN',
    'HELVOIRT',
    'HELWERD',
    'HELWIJK',
    'HEM',
    'HEMELUM',
    'HEMERT',
    'HEMMEN',
    'HEMPENS',
    'HEMRIK',
    'HEMRIKERVERLAAT',
    'HENDRIK IDO AMBACHT',
    'HENGELAND',
    'HENGELO',
    'HENGEVELDE',
    'HENGFORDEN',
    'HENGSTDIJK',
    'HENGSTHEUVEL',
    'HENNAARD',
    'HENSBROEK',
    'HERBAIJUM',
    'HERFTE',
    'HERIKE',
    'HERKENBOSCH',
    'HERKENRADE',
    'HERKINGEN',
    'HERMALEN',
    'HERNEN',
    'HERPEN',
    'HERPT',
    'HERSEL',
    'HERSEND',
    'HERT',
    'HERTEN',
    'HERTME',
    'HERVELD',
    'HERVELD NOORD',
    'HERVELD ZUID',
    'HERWEN',
    'HERWIJNEN',
    'HERXEN',
    'HESENS',
    'HESPELAAR',
    'HESSUM',
    'HET',
    'HET BEGGELDER',
    'HET BEIJERSCHE',
    'HET BOSCH',
    'HET BROEK',
    'HET GOORDONK',
    'HET HEIKE',
    'HET HOEKSKE',
    'HET KUSTLICHT',
    'HET LAAR',
    'HET LOO',
    'HET MOER',
    'HET OOSTEIND',
    'HET OUDELAND',
    'HET REIDLAND',
    'HET SAS',
    'HET SCHIER',
    'HET STIFT',
    'HET VEEN',
    'HET VONDEREN',
    'HET VORST',
    'HET WESTEINDE',
    'HET WILD',
    'HETEREN',
    'HEUGDE',
    'HEUKELOM',
    'HEUKELUM',
    'HEULT',
    'HEUMEN',
    'HEURE',
    'HEURNE',
    'HEUSDEN',
    'HEUVEL',
    'HEUVELBERG',
    'HEUVELSTRAAT',
    'HEUVELTJE',
    'HEUVEN',
    'HEVEADORP',
    'HEXEL',
    'HEYTHUYSEN',
    'HEZELAAR',
    'HEZINGEN',
    'HIAURE',
    'HICHTUM',
    'HIDAARD',
    'HIEN',
    'HIERDEN',
    'HIESLUM',
    'HIJKEN',
    'HIJKERSMILDE',
    'HIJLAARD',
    'HIJUM',
    'HILAARD',
    'HILAKKER',
    'HILD',
    'HILL',
    'HILLEGOM',
    'HILLESHAGEN',
    'HILVARENBEEK',
    'HILVERSUM',
    'HILVERSUMSE MEENT',
    'HIMERT',
    'HIMMELUM',
    'HIMPENS',
    'HIMRIKERFALLAAT',
    'HINDELOOPEN',
    'HINGEN',
    'HINNAARD',
    'HINTHAM',
    'HIPPOLYTUSHOEF',
    'HITSERTSE KADE',
    'HITSUM',
    'HITZUM',
    'HJERBEAM',
    'HO O GEBIEZEN',
    'HOARNE',
    'HOARNSTERSWEACH',
    'HOBBELRADE',
    'HOBREDE',
    'HOCHTE',
    'HODENPIJL',
    'HOEDEKENSKERKE',
    'HOEF',
    'HOEF EN HAAG',
    'HOEFKENS',
    'HOEK',
    'HOEK VAN DE DIJK',
    'HOEK VAN HOLLAND',
    'HOEKDRIES',
    'HOEKEINDE',
    'HOEKELUM',
    'HOEKENS',
    'HOEKJE',
    'HOEKSKE',
    'HOEKSMEER',
    'HOENDERLOO',
    'HOENKOOP',
    'HOENSBROEK',
    'HOENZADRIEL',
    'HOETMANSMEER',
    'HOEVE',
    'HOEVELAKEN',
    'HOEVEN',
    'HOEVES',
    'HOEVESTEIN',
    'HOF',
    'HOFKE',
    'HOGE ENK',
    'HOGE HEXEL',
    'HOGE LINTHORST',
    'HOGEBEINTUM',
    'HOGEBRUG',
    'HOGEVEEN',
    'HOGEWEG',
    'HOLK',
    'HOLKERVEEN',
    'HOLLANDER',
    'HOLLANDSCHE RADING',
    'HOLLANDSCHEVELD',
    'HOLLANDSDIEP',
    'HOLLENBERG',
    'HOLLEVOETERBRUG',
    'HOLLUM',
    'HOLSET',
    'HOLSLOOT',
    'HOLST',
    'HOLT',
    'HOLTE',
    'HOLTEN',
    'HOLTERHOEK',
    'HOLTHE',
    'HOLTHEES',
    'HOLTHEME',
    'HOLTHONE',
    'HOLTHUIZEN',
    'HOLTIEN',
    'HOLTINGE',
    'HOLTLAND',
    'HOLTUM',
    'HOLWERD',
    'HOLWERT',
    'HOLWIERDE',
    'HOLWINDE',
    'HOLYSLOOT',
    'HOMBERG',
    'HOMMELSE HOEVEN',
    'HOMMERT',
    'HOMMERTS',
    'HOMOET',
    'HONDERD',
    'HONDSEIND',
    'HONDSRUG',
    'HONESCH',
    'HONGERIGE WOLF',
    'HONSELERSDIJK',
    'HONSWIJK',
    'HONTHEM',
    'HOOFDDORP',
    'HOOFDPLAAT',
    'HOOG BAARLO',
    'HOOG BUURLO',
    'HOOG CAESTERT',
    'HOOG KANA',
    'HOOG KEPPEL',
    'HOOG SOEREN',
    'HOOG SPUL',
    'HOOG ZUTHEM',
    'HOOGBLOKLAND',
    'HOOGBROEK',
    'HOOGCASTEREN',
    'HOOGCRUTS',
    'HOOGE AARD',
    'HOOGE BERKT',
    'HOOGE HEIDE',
    'HOOGE MIERDE',
    'HOOGE WIJST',
    'HOOGE ZWALUWE',
    'HOOGEDIJK',
    'HOOGEDUURSWOUDE',
    'HOOGEHAAR',
    'HOOGEIND',
    'HOOGELANDE',
    'HOOGELOON',
    'HOOGEN AARLE',
    'HOOGENGRAVEN',
    'HOOGENWEG',
    'HOOGERHEIDE',
    'HOOGERSMILDE',
    'HOOGEVEEN',
    'HOOGEWEG',
    'HOOGEZAND',
    'HOOGHALEN',
    'HOOGHOUT',
    'HOOGKARSPEL',
    'HOOGKERK',
    'HOOGLAND',
    'HOOGLANDERVEEN',
    'HOOGMADE',
    'HOOGMEIEN',
    'HOOGRIEBROEK',
    'HOOGSTRAAT',
    'HOOGVELD',
    'HOOGVLIET',
    'HOOGWATUM',
    'HOOGWOUD',
    'HOOGZAND OOSTERMEER',
    'HOOIBERGEN',
    'HOOIDONK',
    'HOOL',
    'HOONHORST',
    'HOONTE',
    'HOORN',
    'HOORNAAR',
    'HOORNDERVEEN',
    'HOORNERVEEN',
    'HOORNSEDIJK',
    'HOORNSTERZWAAG',
    'HOPTILLE',
    'HORICK',
    'HORN',
    'HORNHUIZEN',
    'HORSSEN',
    'HORST',
    'HORSTEN',
    'HORSTHOEK',
    'HORZIK',
    'HOUT',
    'HOUT BLERICK',
    'HOUTBROEK',
    'HOUTDORP',
    'HOUTEN',
    'HOUTERD',
    'HOUTGOOR',
    'HOUTHEI',
    'HOUTHEM',
    'HOUTHUIZEN',
    'HOUTIGEHAGE',
    'HOUTSESTRAAT',
    'HOUWERZIJL',
    'HUB',
    'HUGTEN',
    'HUIJ',
    'HUIJBERGEN',
    'HUINEN',
    'HUINERBROEK',
    'HUINERWAL',
    'HUINS',
    'HUIS TER HEIDE',
    'HUISDUINEN',
    'HUISSELING',
    'HUISSEN',
    'HUISVENNEN',
    'HUIZE PADUA',
    'HUIZEN',
    'HUIZERHOOGT',
    'HUIZINGE',
    'HULHUIZEN',
    'HULS',
    'HULSBEEK',
    'HULSBERG',
    'HULSDONK',
    'HULSEL',
    'HULSEN',
    'HULSHORST',
    'HULST',
    'HULTEN',
    'HULTJE',
    'HUMCOVEN',
    'HUMMELO',
    'HUNNECUM',
    'HUNS',
    'HUNSEL',
    'HUPSEL',
    'HURDEGARYP',
    'HURKSKE',
    'HURPESCH',
    'HURWENEN',
    'HUSHOVEN',
    'HUSSENBERG',
    'HUSTERNOARD',
    'HUURNE',
    'HUYGEVOORT',
    'HYLPEN',
    'HYUM',
    'HÖCHTE',
    'HÖFKE',
    'HÚNS',
    'HÛSTERNOARD',
    'IDAARD',
    'IDAERD',
    'IDSEGAHUIZUM',
    'IDSERDABUREN',
    'IDSKENHUIZEN',
    'IDZEGA',
    'IDZEGEA',
    'IDZERDABUORREN',
    'IENS',
    'IEZUMASYL',
    'IJHORST',
    'IJLST',
    'IJMUIDEN',
    'IJPELAAR',
    'IJSSELHAM',
    'IJSSELLAAN',
    'IJSSELMUIDEN',
    'IJSSELSTEIN',
    'IJZENDIJKE',
    'IJZENDOORN',
    'IJZEREN',
    'IJZERLO',
    'IJZEVOORDE',
    'ILLIKHOVEN',
    'ILPENDAM',
    'IMSTENRADE',
    'IN DE HOEVEN',
    'INDIJK',
    'INDOORNIK',
    'INGBER',
    'INGELUM',
    'INGEN',
    'INGWERT',
    'INGWIERRUM',
    'INIAHEIDE',
    'IRNSUM',
    'ISABELLAHAVEN',
    'IT FLIET',
    'IT HEARRENFEAN',
    'IT HEECHSAN',
    'IT HEECHSÂN',
    'IT HEIDENSKIP',
    'IT ORANJEWALD',
    'IT ORANJEWÂLD',
    'ITENS',
    'ITTEREN',
    'ITTERVOORT',
    'JAARSVELD',
    'JABEEK',
    'JAGERSWIJK',
    'JANDERUM OF LJANDERUM',
    'JANNENDORP',
    'JANNUM',
    'JANUM',
    'JELLUM',
    'JELSUM',
    'JETH',
    'JEWIER',
    'JIPSINGBOERMUSSEL',
    'JIPSINGBOERTANGE',
    'JIPSINGHUIZEN',
    'JIRNSUM',
    'JISKENHUZEN',
    'JISLUM',
    'JISP',
    'JISTERGEA',
    'JISTRUM',
    'JOBBEGEA',
    'JONAS',
    'JONEN',
    'JONKERSHUIZEN',
    'JONKERSLAN',
    'JONKERSLAND',
    'JONKERSLÂN',
    'JONKERSVAART',
    'JOOSSESWEG',
    'JOPPE',
    'JORWERD',
    'JORWERT',
    'JOURE',
    'JOUSTERP',
    'JOUSWERD',
    'JOUSWIER',
    'JUBBEGA',
    'JUBBEGA SCHUREGA',
    'JUKWERD',
    'JULIANADORP',
    'JUNNE',
    'JUTRIJP',
    'JUTRYP',
    'KAAG',
    'KAAKHORN',
    'KAARD',
    'KAARSCHOT',
    'KAART',
    'KAATHOVEN',
    'KAATSHEUVEL',
    'KADE',
    'KADIJK',
    'KADOELEN',
    'KALENBERG',
    'KALISHOEK',
    'KALKWIJK',
    'KALLENBROEK',
    'KALLENKOTE',
    'KALTEREN',
    'KALVERDIJK',
    'KAMEREN',
    'KAMERIK',
    'KAMP',
    'KAMPEN',
    'KAMPEREILAND',
    'KAMPERHOEK',
    'KAMPERLAND',
    'KAMPERSCHE HOEK',
    'KAMPERSHOEK',
    'KAMPERVEEN',
    'KAMPERZEEDIJK OOST',
    'KAMPERZEEDIJK WEST',
    'KANIS',
    'KANTENS',
    'KANTJE',
    'KAPEL',
    'KAPEL AVEZAATH',
    'KAPELEIND',
    'KAPELLE',
    'KAPELLEBRUG',
    'KAPOLDER',
    'KAPPERT',
    'KARREVELD',
    'KARSTRAAT',
    'KASEN',
    'KASTEREN',
    'KATERBOSCH',
    'KATERSHORN',
    'KATERVEER',
    'KATHAGEN',
    'KATLIJK',
    'KATS',
    'KATSBERG',
    'KATTENBERG',
    'KATTENDIJKE',
    'KATWIJK',
    'KATWIJK AAN DEN RIJN',
    'KATWIJK AAN ZEE',
    'KATWIJKERLAAN',
    'KATWOUDE',
    'KAUMESHOEK',
    'KAVELINGEN',
    'KAWEIDE',
    'KEATLINGWIER',
    'KEDICHEM',
    'KEENT',
    'KEERSOP',
    'KEIENDORP',
    'KEIJENBORG',
    'KEIMPETILLE',
    'KEINSMERBRUG',
    'KEIZERRIJK',
    'KEIZERSDIJK',
    'KEIZERSHOEK',
    'KEIZERSVEER',
    'KEKERDOM',
    'KELDONK',
    'KELMOND',
    'KELPEN',
    'KELPEN OLER',
    'KERK AVEZAATH',
    'KERKBUURT',
    'KERKDORP',
    'KERKDRIEL',
    'KERKEIND',
    'KERKEINDE',
    'KERKENVELD',
    'KERKHOF',
    'KERKLAAN',
    'KERKRADE',
    'KERKWERVE',
    'KERKWIJK',
    'KESKE',
    'KESSEL',
    'KESSELEIK',
    'KESTEREN',
    'KETELHAVEN',
    'KETLIK',
    'KETTINGWIER',
    'KEULSE KAMP',
    'KEUNENHOEK',
    'KEUNINGSWIJK',
    'KEUP',
    'KEUTENBERG',
    'KEUTER',
    'KIBBELGAARN',
    'KIBBELVEEN',
    'KIE',
    'KIEL WINDEWEER',
    'KIESTERSYL',
    'KIESTERZIJL',
    'KIEVITSDEL',
    'KIEVITSHAAR',
    'KIEVITSNEST',
    'KIEVITSWAARD',
    'KIJFHOEK',
    'KIJFWAARD',
    'KIJKUIT',
    'KILDER',
    'KILLE',
    'KIMSWERD',
    'KIMSWERT',
    'KINDERBOS',
    'KINDERDIJK',
    'KINGMATILLE',
    'KINKHOVEN',
    'KINNUM',
    'KINUM',
    'KIPPEREIND',
    'KIVITSBRAAK',
    'KLAARSTRAAT',
    'KLAASWAAL',
    'KLADDE',
    'KLARENBEEK',
    'KLATERING',
    'KLAZIENAVEEN',
    'KLAZIENAVEEN NOORD',
    'KLEASTER LIDLUM',
    'KLEEBERG',
    'KLEF',
    'KLEI',
    'KLEIN AGELO',
    'KLEIN AMSTERDAM',
    'KLEIN AZEWIJN',
    'KLEIN BAAL',
    'KLEIN BEDAF',
    'KLEIN BRUGGEN',
    'KLEIN DOCHTEREN',
    'KLEIN DOENRADE',
    'KLEIN DONGEN',
    'KLEIN GARNWERD',
    'KLEIN GENHOUT',
    'KLEIN GRONINGEN',
    'KLEIN HAASDAL',
    'KLEIN HANSSUM',
    'KLEIN HITLAND',
    'KLEIN LEGER',
    'KLEIN LOO',
    'KLEIN MARIEKERKE',
    'KLEIN MEDHUIZEN MIDHUIZEN',
    'KLEIN OEKEL',
    'KLEIN OIRLO',
    'KLEIN SCHOOT',
    'KLEIN ULSDA',
    'KLEIN VALKENISSE',
    'KLEIN VORTUM',
    'KLEIN WELSDEN',
    'KLEIN WETSINGE',
    'KLEIN ZUNDERT',
    'KLEINDER LIEMPDE',
    'KLEINDORP',
    'KLEINE BOTTEL',
    'KLEINE GAASTMEER',
    'KLEINE GEEST',
    'KLEINE HORST',
    'KLEINE HUISJES',
    'KLEINE KOOLWIJK',
    'KLEINE LINDT',
    'KLEINE MEERS',
    'KLEINE SLUIS',
    'KLEINE VOORT',
    'KLEINE WISKE',
    'KLEINEMEER',
    'KLEINGENHOUT',
    'KLETTERBUORREN',
    'KLETTERBUURT',
    'KLEVERSKERKE',
    'KLIJNDIJK',
    'KLIMMEN',
    'KLINKENBERG',
    'KLISPOEL',
    'KLOETINGE',
    'KLOOSTER',
    'KLOOSTER LIDLUM',
    'KLOOSTERBUREN',
    'KLOOSTEREIND',
    'KLOOSTERHAAR',
    'KLOOSTERVEEN',
    'KLOOSTERZANDE',
    'KLOSSEHOEK',
    'KLUNDERT',
    'KLUTSDORP',
    'KLÖSSEHOEK',
    'KNAPHOF',
    'KNEGSEL',
    'KNIKKERDORP',
    'KNUITERSHOEK',
    'KOALDUM',
    'KOARNJUM',
    'KOARNWERT',
    'KOARTEHIMMEN',
    'KOARTSWEAGEN',
    'KOARTWALD',
    'KOARTWÂLD',
    'KOATSTERTILLE',
    'KOCKENGEN',
    'KOEDIJK',
    'KOEDOOD',
    'KOEHOAL',
    'KOEHOOL',
    'KOEKANGE',
    'KOEKANGERVELD',
    'KOEKOEK',
    'KOELVEEN',
    'KOEVERING',
    'KOEWACHT',
    'KOKKELERT',
    'KOLDERVEEN',
    'KOLDERVEENSE BOVENBOER',
    'KOLDERWALDE',
    'KOLDERWOLDE',
    'KOLDERWÂLDE',
    'KOLHAM',
    'KOLHOL',
    'KOLHORN',
    'KOLLUM',
    'KOLLUMEROUDZIJL',
    'KOLLUMERPOMP',
    'KOLLUMERSWEACH',
    'KOLLUMERZWAAG',
    'KOLTHOORN',
    'KOMMERDIJK',
    'KOMMERZIJL',
    'KONINGINNEHAVEN',
    'KONINGSBOSCH',
    'KONINGSLUST',
    'KONINGSOORD',
    'KOOG AAN DE ZAAN',
    'KOOIHUIZEN',
    'KOOIWIJK',
    'KOOLDERT',
    'KOOLWIJK',
    'KOOTSTERTILLE',
    'KOOTWIJK',
    'KOOTWIJKERBROEK',
    'KOP VAN T LAND',
    'KOPAF',
    'KOPSTUKKEN',
    'KORENGARST',
    'KORHORN',
    'KORN',
    'KORNHORN',
    'KORNWERDERZAND',
    'KORTE AKKERS',
    'KORTE HEIDE',
    'KORTEHEMMEN',
    'KORTENHOEF',
    'KORTENHOEVEN',
    'KORTENOORD',
    'KORTERAAR',
    'KORTEVEN',
    'KORTEZWAAG',
    'KORTGENE',
    'KORTGERECHT',
    'KORTLAND',
    'KORTRIJK',
    'KORTWOUDE',
    'KOSBERG',
    'KOSTVERLOREN',
    'KOSTVLIES',
    'KOUDEHOEK',
    'KOUDEHUIZUM',
    'KOUDEKERK AAN DEN RIJN',
    'KOUDEKERKE',
    'KOUDENHOEK',
    'KOUDHOORN',
    'KOUDUM',
    'KOUFURDERRIGE',
    'KOULEN',
    'KOUWENBERG',
    'KRAAN',
    'KRAANMEER',
    'KRAANVEN',
    'KRAB BE BUREN',
    'KRABBENDAM',
    'KRABBENDIJKE',
    'KRABBENHOEK',
    'KRACHTIGHUIZEN',
    'KRAGGENBURG',
    'KRALOO',
    'KRANENBROEK',
    'KRANENBURG',
    'KRANENDIJK',
    'KRASSUM',
    'KREEK',
    'KREIELT',
    'KREIJEL',
    'KREIJL',
    'KREILEROORD',
    'KREITSBERG',
    'KREMSEL',
    'KREVERHILLE',
    'KREWERD',
    'KRIMPEN AAN DE LEK',
    'KRIMPEN AAN DEN IJSSEL',
    'KRING VAN DORTH',
    'KROLHOEK',
    'KROMME ELLEBOOG',
    'KROMME MIJDRECHT',
    'KROMMENHOEKE',
    'KROMMENIE',
    'KROMWIJK',
    'KRONENBERG',
    'KROPSWOLDE',
    'KROSSELT',
    'KRUININGEN',
    'KRUININGERGORS',
    'KRUISBERG',
    'KRUISDIJK',
    'KRUISDORP',
    'KRUISELWERK',
    'KRUISHAAR',
    'KRUISLAND',
    'KRUISPOLDERHAVEN',
    'KRUISPUNT',
    'KRUISSTRAAT',
    'KRUISWEG',
    'KUBAARD',
    'KUDELSTAART',
    'KUFURDERRIGE',
    'KUIKHORNE',
    'KUIKSCHE HEIDE',
    'KUIKSEIND',
    'KUILENRODE',
    'KUINRE',
    'KUIPERSVEER',
    'KUITAART',
    'KUIVEZAND',
    'KUKHERNE',
    'KULERT',
    'KULSDOM',
    'KUNRADE',
    'KUTTINGEN',
    'KUUNDERT',
    'KUZEMER',
    'KUZEMERBALK',
    'KWAALBURG',
    'KWADENDAMME',
    'KWADIJK',
    'KWAKKEL',
    'KWARTIER',
    'KWINTSHEUL',
    'KÛBAARD',
    'KÛFURDERRIGE',
    'KÛKHERNE',
    'L AIR PUR',
    'LAAG CAESTERT',
    'LAAG HEUKELOM',
    'LAAG KEPPEL',
    'LAAG SOEREN',
    'LAAG SPUL',
    'LAAG ZUTHEM',
    'LAAGDUURSWOUDE',
    'LAAGEIND',
    'LAAGHALEN',
    'LAAGHALERVEEN',
    'LAAGHEIDE',
    'LAAGNIEUWKOOP',
    'LAAGRIEBROEK',
    'LAAGSTRAAT',
    'LAAK',
    'LAAKSUM',
    'LAAR',
    'LAARBROEK',
    'LAAREIND',
    'LAARSTRAAT',
    'LAAXUM',
    'LAGE AARD',
    'LAGE BERKT',
    'LAGE BIJSSEL',
    'LAGE MIERDE',
    'LAGE VUURSCHE',
    'LAGE WEG',
    'LAGE WIJST',
    'LAGE ZWALUWE',
    'LAGEBIEZEN',
    'LAGEBROEK',
    'LAGEKANT',
    'LAGELAND',
    'LAGENHEUVEL',
    'LAGEWEG',
    'LAKEI',
    'LAKERVELD',
    'LALLEWEER',
    'LAMBERTSCHAAG',
    'LAMMERBUREN',
    'LAMMERWEG',
    'LAMPEREN',
    'LAMSWAARDE',
    'LAND VAN KLEEF',
    'LANDERUM',
    'LANDHORST',
    'LANDORP',
    'LANDSMEER',
    'LANDSRADE',
    'LANG HOUT',
    'LANGBROEK',
    'LANGE HEIDE',
    'LANGE LINSCHOTEN',
    'LANGEDIJKE N',
    'LANGEDIKE',
    'LANGELILLE',
    'LANGELO',
    'LANGENBERG',
    'LANGENBOOM',
    'LANGENDIJK',
    'LANGENHOLTE',
    'LANGERAAR',
    'LANGERAK',
    'LANGEREIT',
    'LANGESCHOUW',
    'LANGEVEEN',
    'LANGEWEEGJE',
    'LANGEWEG',
    'LANGEWEIDE',
    'LANGEZWAAG',
    'LANGLAAR',
    'LANGSTRAAT',
    'LANGSWEAGEN',
    'LANGWAR',
    'LANGWEER',
    'LANKES',
    'LANKHORST',
    'LAREN',
    'LASKWERD',
    'LATHUM',
    'LATTROP',
    'LATTROP BREKLENKAMP',
    'LAUDE',
    'LAUDERMARKE',
    'LAUDERZWARTEVEEN',
    'LAUWERSOOG',
    'LAUWERZIJL',
    'LEDE EN OUDEWAARD',
    'LEDEACKER',
    'LEECH DUERSWALD',
    'LEECH DUERSWÂLD',
    'LEEGKERK',
    'LEEGTE',
    'LEEK',
    'LEEMBERG',
    'LEEMDOBBEN',
    'LEEMHORST',
    'LEENDE',
    'LEENDERSTRIJP',
    'LEENS',
    'LEENSEL',
    'LEERBROEK',
    'LEERDAM',
    'LEERMENS',
    'LEERSUM',
    'LEEUW',
    'LEEUWARDEN',
    'LEEUWERIK',
    'LEEUWTE',
    'LEG',
    'LEGEMAR',
    'LEGEMEER',
    'LEGERT',
    'LEGGELOO',
    'LEIDEN',
    'LEIDERDORP',
    'LEIDSCHENDAM',
    'LEIMUIDEN',
    'LEIMUIDERBRUG',
    'LEKERMEER',
    'LEKKERKERK',
    'LEKKUM',
    'LELLENS',
    'LELYSTAD',
    'LEMEL',
    'LEMELE',
    'LEMELERVELD',
    'LEMIERS',
    'LEMMER',
    'LEMSELO',
    'LENGEL',
    'LENNISHEUVEL',
    'LENT',
    'LENTHE',
    'LEONS',
    'LEPELSTRAAT',
    'LEROP',
    'LETTELBERT',
    'LETTELE',
    'LEUNEN',
    'LEUR',
    'LEUSDEN',
    'LEUSDEN ZUID',
    'LEUTES',
    'LEUTH',
    'LEUTINGEWOLDE',
    'LEUVEN',
    'LEUVENHEIM',
    'LEUVENUM',
    'LEVEROIJSE BERGEN',
    'LEVEROY',
    'LEWEDORP',
    'LEXMOND',
    'LHEE',
    'LHEEBROEK',
    'LIBEEK',
    'LICHTAARD',
    'LICHTENVOORDE',
    'LICHTMIS',
    'LIEFKENSHOEK',
    'LIEMPDE',
    'LIENDEN',
    'LIERDERHOLTHUIS',
    'LIEREN',
    'LIERHAND',
    'LIEROP',
    'LIES',
    'LIESEIND',
    'LIESHOUT',
    'LIESSEL',
    'LIEVELD',
    'LIEVELDE',
    'LIEVEREN',
    'LIEVING',
    'LIGTENBERG',
    'LIJNDEN',
    'LIJNDONK',
    'LIJTSHUIZEN',
    'LIMBRICHT',
    'LIMMEN',
    'LINDE',
    'LINDEN',
    'LINGSFORT',
    'LINNE',
    'LINSCHOTEN',
    'LINTELO',
    'LINTVELDE',
    'LIOESSENS',
    'LIONS',
    'LIPPENHUIZEN',
    'LIPPENHUZEN',
    'LIPPENWOUDE',
    'LISSE',
    'LISSERBROEK',
    'LITH',
    'LITHOIJEN',
    'LJOUWERT',
    'LJUSSENS',
    'LOAIINGEA',
    'LOAIÏNGEA',
    'LOBITH',
    'LOCHEM',
    'LOCHT',
    'LOCHUIZEN',
    'LOENEN',
    'LOENEN AAN DE VECHT',
    'LOENERSLOOT',
    'LOENGA',
    'LOERBEEK',
    'LOESWIJK',
    'LOETE',
    'LOIL',
    'LOLLUM',
    'LOMM',
    'LONGERHOU',
    'LONGERHOUW',
    'LONNEKER',
    'LOO',
    'LOOBEEK',
    'LOOBRINK',
    'LOOIEIND',
    'LOOIENHOEK',
    'LOOIWINKEL',
    'LOOK',
    'LOON',
    'LOON OP ZAND',
    'LOONEIND',
    'LOONS HOEKJE',
    'LOONSE HOEK',
    'LOOPERSKAPELLE',
    'LOOSBROEK',
    'LOOSDORP',
    'LOOSDRECHT',
    'LOOVEER',
    'LOOZEN',
    'LOPIK',
    'LOPIKERKAPEL',
    'LOPPERSUM',
    'LOSDORP',
    'LOSSER',
    'LOTTUM',
    'LOVENDAAL',
    'LOVEREN',
    'LOËNGA',
    'LUBBINGE',
    'LUCASWOLDE',
    'LUCHEN',
    'LUCHTENBURG',
    'LUCHTENVELD',
    'LUDDEWEER',
    'LUINJEBERD',
    'LUISSEL',
    'LUITERT',
    'LUKSWALD',
    'LULA',
    'LUNBERT',
    'LUNEN',
    'LUNSSLOTEN',
    'LUNTEREN',
    'LUNTERSHOEK',
    'LUTJEBROEK',
    'LUTJEGAST',
    'LUTJELOLLUM',
    'LUTJELOO',
    'LUTJERIJP',
    'LUTJEWIJTWERD',
    'LUTJEWINKEL',
    'LUTJEWOLDE',
    'LUTKEPOST',
    'LUTKEWIERUM',
    'LUTSJELOLLUM',
    'LUTTELGEEST',
    'LUTTELHERPT',
    'LUTTEN',
    'LUTTEN OEVER',
    'LUTTENBERG',
    'LUTTERHARTJE',
    'LUTTERVELD',
    'LUXWOUDE',
    'LUYKSGESTEL',
    'LYTS MIDHUZEN',
    'LYTSE GEAST',
    'LYTSEPOST',
    'LYTSEWALD',
    'LYTSEWIERRUM',
    'LYTSEWÂLD',
    'LYTSHUZEN',
    'LÚKSWÂLD',
    'LÚNBERT',
    'MAAGD VAN GENT',
    'MAAIDIJK',
    'MAAIJKANT',
    'MAALBERGEN',
    'MAALBROEK',
    'MAALDRIFT',
    'MAALSTEDE',
    'MAARHEEZE',
    'MAARHUIZEN',
    'MAARN',
    'MAARSBERGEN',
    'MAARSSEN',
    'MAARTENSDIJK',
    'MAASBAND',
    'MAASBOMMEL',
    'MAASBRACHT',
    'MAASBREE',
    'MAASDAM',
    'MAASDIJK',
    'MAASHEES',
    'MAASKANT',
    'MAASKANTJE',
    'MAASLAND',
    'MAASSLUIS',
    'MAASTRICHT',
    'MAASTRICHT AIRPORT',
    'MAASVLAKTE',
    'MAATSEHEI',
    'MACHAREN',
    'MADE',
    'MAGELE',
    'MAGRETTE',
    'MAKKINGA',
    'MAKKINGEA',
    'MAKKUM',
    'MALDEN',
    'MALLAND',
    'MALLEM',
    'MAMELIS',
    'MANDER',
    'MANDERVEEN',
    'MANEN',
    'MANTGUM',
    'MANTINGE',
    'MAREN',
    'MAREN KESSEL',
    'MARGRATEN',
    'MARIA HEIDE',
    'MARIA HOOP',
    'MARIADORP',
    'MARIAHEIDE',
    'MARIAHOUT',
    'MARIAPAROCHIE',
    'MARIENBERG',
    'MARIENDIJK',
    'MARIENHEEM',
    'MARIENVELDE',
    'MARIJENKAMPEN',
    'MARIS',
    'MARIËNBERG',
    'MARIËNDIJK',
    'MARIËNHEEM',
    'MARIËNVELDE',
    'MARKELO',
    'MARKEN',
    'MARKENBINNEN',
    'MARKLUIDEN',
    'MARKNESSE',
    'MARKVELDE',
    'MARLE',
    'MAROLLEPUT',
    'MARRUM',
    'MARSSUM',
    'MARSUM',
    'MARTENSHOEK',
    'MARUM',
    'MARWIJKSOORD',
    'MASTENBROEK',
    'MASTWIJK',
    'MATARAM',
    'MATHIJSEIND',
    'MATSLOOT',
    'MAURIK',
    'MAURITSFORT',
    'MAXET',
    'MECHELEN',
    'MEDEMBLIK',
    'MEDEVOORT',
    'MEDLER',
    'MEEDEN',
    'MEEDHUIZEN',
    'MEEMORTEL',
    'MEER',
    'MEEREN',
    'MEERENBROEK',
    'MEERKERK',
    'MEERLAND',
    'MEERLO',
    'MEERS',
    'MEERSSEN',
    'MEERSTAD',
    'MEERTEN',
    'MEERTENWEI',
    'MEERVELD',
    'MEERVEN',
    'MEERWIJCK',
    'MEEUWEN',
    'MEGCHELEN',
    'MEGELSUM',
    'MEGEN',
    'MEIJE',
    'MEIJEL',
    'MEIJLDOORN',
    'MEIJSBERG',
    'MEILAHUIZEN',
    'MEILAHUZEN',
    'MEKKELHORST',
    'MELDERSLO',
    'MELICK',
    'MELISKERKE',
    'MELISSANT',
    'MELLESCHET',
    'MENAAM',
    'MENALDUM',
    'MENNONIETENBUURT',
    'MENSINGEWEER',
    'MENZEL',
    'MEPPEL',
    'MEPPEN',
    'MERKELBEEK',
    'MERLENBERG',
    'MERSELO',
    'MERUM',
    'MESCH',
    'METEREN',
    'METERIK',
    'METSLAWIER',
    'MEULUNTEREN',
    'MHEER',
    'MIDBUUL',
    'MIDDEL',
    'MIDDELAAR',
    'MIDDELBEERS',
    'MIDDELBERT',
    'MIDDELBUREN',
    'MIDDELBURG',
    'MIDDELDIJK',
    'MIDDELHARNIS',
    'MIDDELIE',
    'MIDDELIJK',
    'MIDDELKOOP',
    'MIDDELRODE',
    'MIDDELSLUIS',
    'MIDDELSTUM',
    'MIDDELVEEN',
    'MIDDENBEEMSTER',
    'MIDDENDORP',
    'MIDDENHOF',
    'MIDDENMEER',
    'MIDLAREN',
    'MIDLUM',
    'MIDSLAN',
    'MIDSLAN OAN SEE',
    'MIDSLAND',
    'MIDSLAND AAN ZEE',
    'MIDSLÂN',
    'MIDSLÂN OAN SEE',
    'MIDWOLDA',
    'MIDWOLDE',
    'MIDWOUD',
    'MIEDUM',
    'MIERLO',
    'MIJDRECHT',
    'MIJNDEN',
    'MIJNSHEERENLAND',
    'MILDAAM',
    'MILDAM',
    'MILDERT',
    'MILHEEZE',
    'MILL',
    'MILLINGEN',
    'MILLINGEN AAN DE RIJN',
    'MILSBEEK',
    'MILSCHOT',
    'MILT',
    'MINGERSBERG',
    'MINKELOOS',
    'MINNERTSGA',
    'MINNERTSGEA',
    'MIRNS',
    'MISPELEIND',
    'MITSELWIER',
    'MOARRE',
    'MODDERGAT',
    'MOERBEEK',
    'MOERDIJK',
    'MOEREN',
    'MOERENBURG',
    'MOERGESTEL',
    'MOERKAPELLE',
    'MOERSLAG',
    'MOERSTRATEN',
    'MOESDIJK',
    'MOESPOT',
    'MOLEMBAIX',
    'MOLENAARSGRAAF',
    'MOLENBAAN',
    'MOLENBELT',
    'MOLENBUURT',
    'MOLENEIND',
    'MOLENEND',
    'MOLENGAT',
    'MOLENHOEK',
    'MOLENHOF',
    'MOLENHUIZEN',
    'MOLENPERK',
    'MOLENPOLDER',
    'MOLENRIJ',
    'MOLENSCHOT',
    'MOLENSTAD',
    'MOLENSTRAAT',
    'MOLENVELD',
    'MOLENVLIET',
    'MOLENWIJK',
    'MOLKWAR',
    'MOLKWERUM',
    'MOLSBERG',
    'MONNICKENDAM',
    'MONNIKENDIJK',
    'MONSTER',
    'MONTFOORT',
    'MONTFORT',
    'MONTSAMABUORREN',
    'MOOK',
    'MOOKHOEK',
    'MOORDHUIZEN',
    'MOORDRECHT',
    'MOORSEL',
    'MOORVELD',
    'MORIAANSHOOFD',
    'MORIGE',
    'MORRA',
    'MORSCHE HOEF',
    'MORTEL',
    'MOSBULTEN',
    'MOSIK',
    'MOSKOU',
    'MOSSEL',
    'MOSSELAAR',
    'MOSSELHOEK',
    'MOST',
    'MOSTHEUVEL',
    'MOUNEBUORREN',
    'MUGGENBEET',
    'MUGGENBERG',
    'MUGGENHOL',
    'MUGGENHOOL',
    'MUIDEN',
    'MUIDERBERG',
    'MUIZENHOL',
    'MULLEGEN',
    'MULLUM',
    'MUN',
    'MUNEIN',
    'MUNNEKEBUORREN',
    'MUNNEKEBUREN',
    'MUNNEKEMOER',
    'MUNNEKENS VINKEL',
    'MUNNEKEZIJL',
    'MUNNIKENHEIDE',
    'MUNSTERGELEEN',
    'MUNSTERSCHEVELD',
    'MUNTENDAM',
    'MUNTSJESYL',
    'MURNS',
    'MUSSCHENDORP',
    'MUSSEL',
    'MUSSELKANAAL',
    'MÛNEIN',
    'NAALDWIJK',
    'NAARDEN',
    'NAARDERBUORREN',
    'NABBEGAT',
    'NACHTEGAAL',
    'NAGELBEEK',
    'NAGELE',
    'NANSUM',
    'NAPELS',
    'NATTENHOVEN',
    'NEDER HARDINXVELD',
    'NEDERASSELT',
    'NEDERBIEL',
    'NEDERHEIDE',
    'NEDERHEMERT',
    'NEDERHEMERT NOORD',
    'NEDERHEMERT ZUID',
    'NEDERHORST DEN BERG',
    'NEDERLAND',
    'NEDERWEERT',
    'NEDERWEERT EIND',
    'NEDERWEERTERDIJK',
    'NEDERWETTEN',
    'NEDERWOUD',
    'NEEDE',
    'NEER',
    'NEERBEEK',
    'NEERBROEK',
    'NEERDORP',
    'NEEREIND',
    'NEERIJNEN',
    'NEERITTER',
    'NEERKANT',
    'NEERLANGEL',
    'NEERLOON',
    'NEERSTEIND',
    'NEERSTRAAT',
    'NEGENHUIZEN',
    'NEKKEVELD',
    'NERGENA',
    'NERHOVEN',
    'NES',
    'NES AAN DE AMSTEL',
    'NESSERSLUIS',
    'NETERSEL',
    'NETTELHORST',
    'NETTERDEN',
    'NIAWIER',
    'NIBBIXWOUD',
    'NIEBERT',
    'NIEHOVE',
    'NIEKERK',
    'NIEMESKANT',
    'NIERHOVEN',
    'NIERSEN',
    'NIESOORD',
    'NIETAP',
    'NIEUW ABEELE',
    'NIEUW ACHT',
    'NIEUW AMERIKA',
    'NIEUW AMSTERDAM',
    'NIEUW ANNERVEEN',
    'NIEUW BALINGE',
    'NIEUW BEERTA',
    'NIEUW BEIJERLAND',
    'NIEUW BERGEN',
    'NIEUW BUINEN',
    'NIEUW DIJK',
    'NIEUW DORDRECHT',
    'NIEUW EN SINT JOOSLAND',
    'NIEUW EN WINNERSTRAAT',
    'NIEUW GASSEL',
    'NIEUW GROEVENBEEK',
    'NIEUW HAAMSTEDE',
    'NIEUW HEETEN',
    'NIEUW LEKKERLAND',
    'NIEUW LOOSDRECHT',
    'NIEUW MILLIGEN',
    'NIEUW NAMEN',
    'NIEUW REEMST',
    'NIEUW RODEN',
    'NIEUW SCHEEMDA',
    'NIEUW SCHOONEBEEK',
    'NIEUW VENNEP',
    'NIEUW VOSSEMEER',
    'NIEUW WEERDINGE',
    'NIEUW WEHL',
    'NIEUW ZWINDEREN',
    'NIEUWAAL',
    'NIEUWDORP',
    'NIEUWE COMPAGNIE',
    'NIEUWE DIJK',
    'NIEUWE KRIM',
    'NIEUWE MOLEN',
    'NIEUWE NIEDORP',
    'NIEUWE PEKELA',
    'NIEUWE SCHANS',
    'NIEUWE STATENZIJL',
    'NIEUWE STRUMPT',
    'NIEUWE TONGE',
    'NIEUWE VAART',
    'NIEUWE WETERING',
    'NIEUWEBILDTZIJL',
    'NIEUWEBRUG',
    'NIEUWEDIEP',
    'NIEUWEGEIN',
    'NIEUWEHORNE',
    'NIEUWEMOLEN',
    'NIEUWENBERG',
    'NIEUWENDIJK',
    'NIEUWENHAGEN',
    'NIEUWENHOORN',
    'NIEUWER TER AA',
    'NIEUWERBRUG AAN DEN RIJN',
    'NIEUWERHOEK',
    'NIEUWERKERK',
    'NIEUWERKERK AAN DEN IJSSEL',
    'NIEUWERKERKE SCHUTJE',
    'NIEUWEROORD',
    'NIEUWERSLUIS',
    'NIEUWESCHANS',
    'NIEUWESCHOOT',
    'NIEUWESLUIS',
    'NIEUWGRAAF',
    'NIEUWKERK',
    'NIEUWKLAP',
    'NIEUWKOOP',
    'NIEUWKUIJK',
    'NIEUWLAND',
    'NIEUWLANDE',
    'NIEUWLANDE COEVORDEN',
    'NIEUWLANDSE MOLEN',
    'NIEUWLEUSEN',
    'NIEUWOLDA',
    'NIEUWOLDA OOST',
    'NIEUWPOORT',
    'NIEUWSTAD',
    'NIEUWSTADT',
    'NIEUWVEEN',
    'NIEUWVLIET',
    'NIEUWVLIET BAD',
    'NIEZIJL',
    'NIFTRIK',
    'NIGTEVECHT',
    'NIJ ALTOENAE',
    'NIJ AMERIKA',
    'NIJ BEETS',
    'NIJBREGE',
    'NIJBROEK',
    'NIJBRÊGE',
    'NIJBUORREN',
    'NIJE SYL',
    'NIJEBERKEAP',
    'NIJEBERKOOP',
    'NIJEGA',
    'NIJEHASKE',
    'NIJEHOLTPADE',
    'NIJEHOLTPEA',
    'NIJEHOLTWALDE',
    'NIJEHOLTWOLDE',
    'NIJEHOLTWÂLDE',
    'NIJELAMER',
    'NIJELEMMER',
    'NIJEMARDUM',
    'NIJEMIRDUM',
    'NIJENKLOOSTER',
    'NIJENSLEEK',
    'NIJESYL',
    'NIJETRIJNE',
    'NIJETRINE',
    'NIJEVEEN',
    'NIJEVEENSE BOVENBOER',
    'NIJEWIER',
    'NIJEZIJL',
    'NIJHOARNE',
    'NIJHOVEN',
    'NIJHUIZUM',
    'NIJHUZUM',
    'NIJKEN',
    'NIJKERK',
    'NIJKERKERVEEN',
    'NIJLAN',
    'NIJLAND',
    'NIJLANDE',
    'NIJLÂN',
    'NIJMEGEN',
    'NIJNSEL',
    'NIJSKOAT',
    'NIJSTAD',
    'NIJSWILLER',
    'NIJVELAAR',
    'NIJVERDAL',
    'NISPEN',
    'NISPENSE ACHTERHOEK',
    'NISSE',
    'NISTELRODE',
    'NOARDBURGUM',
    'NOARDEIN',
    'NOARDWALDE',
    'NOARDWALDE SUD',
    'NOARDWÂLDE',
    'NOARDWÂLDE SÚD',
    'NOENES',
    'NOETSELE',
    'NOLDE',
    'NOOITGEDACHT',
    'NOORBEEK',
    'NOORD',
    'NOORD DEURNINGEN',
    'NOORD EMPE',
    'NOORD MEER',
    'NOORD SCHARWOUDE',
    'NOORD SLEEN',
    'NOORD STEGEREN',
    'NOORDBARGE',
    'NOORDBEEMSTER',
    'NOORDBERGUM DORP',
    'NOORDBROEK',
    'NOORDBROEKSTERHAMRIK',
    'NOORDDIJK',
    'NOORDEIND',
    'NOORDEINDE',
    'NOORDELOOS',
    'NOORDEN',
    'NOORDERBUREN',
    'NOORDERHOOGEBRUG',
    'NOORDERKOLONIE',
    'NOORDGOUWE',
    'NOORDHOEK',
    'NOORDHORN',
    'NOORDHORNERGA',
    'NOORDHORNERTOLHEK',
    'NOORDIJK',
    'NOORDINK',
    'NOORDKANT',
    'NOORDLAREN',
    'NOORDPOLDERZIJL',
    'NOORDSCHANS',
    'NOORDSCHESCHUT',
    'NOORDSE DORP',
    'NOORDSEBUURT',
    'NOORDSTRAAT',
    'NOORDWELLE',
    'NOORDWIJK',
    'NOORDWIJK AAN ZEE',
    'NOORDWIJK BINNEN',
    'NOORDWIJKERHOUT',
    'NOORDWOLDE',
    'NOORDWOLDE ZUID',
    'NOORDZIJDE',
    'NOOTDORP',
    'NORG',
    'NORGERVAART',
    'NOTENDAAL',
    'NOTSEL',
    'NOTTER',
    'NOUKOOP',
    'NUENEN',
    'NUIJENEIND',
    'NUIL',
    'NUIS',
    'NULAND',
    'NUMANSDORP',
    'NUMERO DERTIEN',
    'NUMMER EEN',
    'NUMMER EÉN',
    'NUNHEM',
    'NUNSPEET',
    'NUTH',
    'NUTTER',
    'NYEGEA',
    'NYKLEASTER',
    'NYLAN',
    'NYLÂN',
    'OBBICHT',
    'OBDAM',
    'OCHTEN',
    'OCKHUIZEN',
    'ODIJK',
    'ODILIAPEEL',
    'ODOORN',
    'OEFFELT',
    'OEGSTGEEST',
    'OEIJENBRAAK',
    'OEKEL',
    'OEKEN',
    'OELE',
    'OENE',
    'OENKERK',
    'OENSEL',
    'OENTSJERK',
    'OERLE',
    'OERTERP',
    'OETELAAR',
    'OEVEREIND',
    'OFFENWIER',
    'OFFINGAWIER',
    'OFWEGEN',
    'OHE EN LAAK',
    'OHÉ EN LAAK',
    'OIJEN',
    'OIRLO',
    'OIRSBEEK',
    'OIRSCHOT',
    'OISTERWIJK',
    'OISTERWIJKSE HOEVEN',
    'OKKENBROEK',
    'OKSWERD',
    'OLBURGEN',
    'OLDEBERKOOP',
    'OLDEBROEK',
    'OLDEHOLTPADE',
    'OLDEHOLTWOLDE',
    'OLDEHOVE',
    'OLDEKERK',
    'OLDELAMER',
    'OLDEMARKT',
    'OLDEN EIBERGEN',
    'OLDENDIEVER',
    'OLDENEEL',
    'OLDENHAVE',
    'OLDENKLOOSTER',
    'OLDENZAAL',
    'OLDENZIJL',
    'OLDEOUWER',
    'OLDETRIJNE',
    'OLDORP',
    'OLDÖRP',
    'OLEN',
    'OLER',
    'OLING',
    'OLLAND',
    'OLST',
    'OLTERTERP',
    'OMMEL',
    'OMMELANDERWIJK',
    'OMMEN',
    'OMMEREN',
    'OMMERENVELD',
    'OMMERSCHANS',
    'ONDER DE MOLEN',
    'ONDER EINDT',
    'ONDERDENDAM',
    'ONDERWIERUM',
    'ONNA',
    'ONNEN',
    'ONSENOORT',
    'ONSTWEDDE',
    'OOIJ',
    'OOIJEN',
    'OOL',
    'OOLDE',
    'OOLTGENSPLAAT',
    'OOMSBERG',
    'OOST GRAFTDIJK',
    'OOST MAARLAND',
    'OOST SOUBURG',
    'OOST VLIELAND',
    'OOST WEST EN MIDDELBEERS',
    'OOSTAPPEN',
    'OOSTBROEK',
    'OOSTBURG',
    'OOSTBURGSCHE BRUG',
    'OOSTBUURT',
    'OOSTDIJK',
    'OOSTEIND',
    'OOSTEINDE',
    'OOSTELBEERS',
    'OOSTENDAM',
    'OOSTER DALFSEN',
    'OOSTERBEEK',
    'OOSTERBIERUM',
    'OOSTERBLOKKER',
    'OOSTERBOORN',
    'OOSTERBROEK',
    'OOSTEREINDE',
    'OOSTEREND',
    'OOSTERENS',
    'OOSTERHESSELEN',
    'OOSTERHOF',
    'OOSTERHOLT',
    'OOSTERHOUT',
    'OOSTERHUIZEN',
    'OOSTERIK',
    'OOSTERLAND',
    'OOSTERLEEK',
    'OOSTERLITTENS',
    'OOSTERMEER',
    'OOSTERNIELAND',
    'OOSTERNIJKERK',
    'OOSTERSE BOS',
    'OOSTERSTREEK',
    'OOSTERWIERUM',
    'OOSTERWIJK',
    'OOSTERWIJTWERD',
    'OOSTERWOLDE',
    'OOSTERZAND',
    'OOSTERZEE',
    'OOSTERZEE BUREN',
    'OOSTHEM',
    'OOSTHOEK',
    'OOSTHUIZEN',
    'OOSTINDIE',
    'OOSTINDIË',
    'OOSTKAPELLE',
    'OOSTKNOLLENDAM',
    'OOSTLAAR',
    'OOSTMAHORN',
    'OOSTRUM',
    'OOSTUM',
    'OOSTVOORNE',
    'OOSTWOLD',
    'OOSTWOLDERPOLDER',
    'OOSTWOUD',
    'OOSTZAAN',
    'OOTMARSUM',
    'OP DE BELT',
    'OP DE BIES',
    'OP DE BOS',
    'OP DE HOVEN',
    'OP DEN BOSCH',
    'OP DEN HERING',
    'OPEINDE',
    'OPENDE',
    'OPHEMERT',
    'OPHEUSDEN',
    'OPHOVEN',
    'OPHUIS',
    'OPHUS',
    'OPHÛS',
    'OPIJNEN',
    'OPLOO',
    'OPMEEDEN',
    'OPMEER',
    'OPPENHUIZEN',
    'OPPERBUREN',
    'OPPERDOES',
    'OPPERDUIT',
    'OPWETTEN',
    'OPWIERDE',
    'ORANJE',
    'ORANJEDORP',
    'ORANJEOORD',
    'ORANJEWOUD',
    'ORVELTE',
    'OSEN',
    'OSHAAR',
    'OSINGAHUIZEN',
    'OSINGAHUZEN',
    'OSPEL',
    'OSPELDIJK',
    'OSS',
    'OSSENDRECHT',
    'OSSENISSE',
    'OSSENWAARD',
    'OSSENZIJL',
    'OSTAAIJEN',
    'OSTERBOS',
    'OTERLEEK',
    'OTHENE',
    'OTTERDIJK',
    'OTTERLO',
    'OTTERSUM',
    'OTTOLAND',
    'OUD AA',
    'OUD ADE',
    'OUD ALBLAS',
    'OUD ANNERVEEN',
    'OUD AVEREEST',
    'OUD BEIJERLAND',
    'OUD BERGENTHEIM',
    'OUD BODEGRAVEN',
    'OUD DIJK',
    'OUD DRIMMELEN',
    'OUD EMPEL',
    'OUD GASTEL',
    'OUD GROEVENBEEK',
    'OUD KAMERIK',
    'OUD KERKHOF',
    'OUD LEMIERS',
    'OUD LEUSDEN',
    'OUD LOOSDRECHT',
    'OUD LUTTEN',
    'OUD MAARSSEVEEN',
    'OUD OOTMARSUM',
    'OUD REEMST',
    'OUD REEUWIJK',
    'OUD ROOSTEREN',
    'OUD SABBINGE',
    'OUD VALKENBURG',
    'OUD VEENINGEN',
    'OUD VERLAAT',
    'OUD VOSSEMEER',
    'OUD WULVEN',
    'OUD ZEVENAAR',
    'OUD ZUILEN',
    'OUDDORP',
    'OUDE BILDTZIJL',
    'OUDE KERK',
    'OUDE LEEDE',
    'OUDE LEIJE',
    'OUDE MAASDIJK',
    'OUDE MEER',
    'OUDE MOLEN',
    'OUDE NIEDORP',
    'OUDE PEKELA',
    'OUDE POLDER',
    'OUDE ROODEHAAN',
    'OUDE SCHOUW',
    'OUDE STATENZIJL',
    'OUDE STEE',
    'OUDE STOOF',
    'OUDE STRUMPT',
    'OUDE TERP',
    'OUDE TONGE',
    'OUDE WARANDA',
    'OUDE WETERING',
    'OUDE WILLEM',
    'OUDEDIJK',
    'OUDEDORP',
    'OUDEGA',
    'OUDEHASKE',
    'OUDEHORNE',
    'OUDELAND',
    'OUDELANDE',
    'OUDEMIRDUM',
    'OUDEMOLEN',
    'OUDENBOSCH',
    'OUDENDIJK',
    'OUDENHOORN',
    'OUDENMOLEN',
    'OUDERKERK AAN DE AMSTEL',
    'OUDERKERK AAN DEN IJSSEL',
    'OUDESCHANS',
    'OUDESCHILD',
    'OUDESCHIP',
    'OUDESCHOOT',
    'OUDESLUIS',
    'OUDEWATER',
    'OUDEWEGSTERVAART',
    'OUDEZIJL',
    'OUDHEUSDEN',
    'OUDKARSPEL',
    'OUDKERK',
    'OUDLEUSEN',
    'OUDORP',
    'OUDWOUDE',
    'OUKOOP',
    'OUSTERHAULE',
    'OUSTERNIJEGEA',
    'OUWENDORP',
    'OUWERKERK',
    'OUWSTER NIJEGA',
    'OUWSTERHAULE',
    'OVENTJE',
    'OVER DE DIJK',
    'OVER DIEMEN',
    'OVERA',
    'OVERAKKER',
    'OVERASSELT',
    'OVERBERG',
    'OVERBIEL',
    'OVERBOEICOP',
    'OVERBROEK',
    'OVERBRUG',
    'OVERDINKEL',
    'OVEREYS',
    'OVERGEUL',
    'OVERHAELEN',
    'OVERHEEK',
    'OVERHEICOP',
    'OVERLANGBROEK',
    'OVERLANGEL',
    'OVERLOON',
    'OVERSCHILD',
    'OVERSCHOT',
    'OVERSLAG',
    'OVERSLINGELAND',
    'OVERVEEN',
    'OVERWATER',
    'OVERWOUD',
    'OVEZANDE',
    'OXE',
    'PAAL',
    'PAARDELANDEN',
    'PAARLO',
    'PAASLOO',
    'PADDEPOEL',
    'PADHUIS',
    'PAESENS',
    'PALLERT',
    'PANDELAARSE KAMPEN',
    'PANDGAT',
    'PANHEEL',
    'PANNENSCHOP',
    'PANNERDEN',
    'PANNINGEN',
    'PAPEKOP',
    'PAPENDRECHT',
    'PAPENHOVEN',
    'PAPENVEER',
    'PAPENVOORT',
    'PARK',
    'PARREGA',
    'PARREGEA',
    'PARTIJ',
    'PASOP',
    'PASSEWAAIJ',
    'PASSLUIS',
    'PATERSWOLDE',
    'PATRIJZENHOEK',
    'PAULUSPOLDER',
    'PEAZENS',
    'PEEBOS',
    'PEELDIJK',
    'PEELKANT',
    'PEELSE HUIS',
    'PEELSEHUIS',
    'PEELSTRAAT',
    'PEERENBOOM',
    'PEEST',
    'PEIJ',
    'PEINS',
    'PEIZE',
    'PEIZERMADE',
    'PEIZERWEG',
    'PEIZERWOLD',
    'PELIKAAN',
    'PELSENDIJK',
    'PENJUM',
    'PEPERGA',
    'PEPERGEA',
    'PEPINUSBRUG',
    'PERNIS',
    'PERNIS ROTTERDAM',
    'PERSINGEN',
    'PESAKEN',
    'PESSE',
    'PETERSBURG',
    'PETTEN',
    'PHILIPPINE',
    'PIAAM',
    'PIEKEZIJL',
    'PIEPERIJ',
    'PIEPERT',
    'PIERIKSMARS',
    'PIERSHIL',
    'PIETERBUREN',
    'PIETERSBIERUM',
    'PIETERZIJL',
    'PIJNACKER',
    'PIJNENBURG',
    'PIKESYL',
    'PIKSEN',
    'PIKVELD',
    'PINGJUM',
    'PINKE N VEER',
    'PITERSBIERRUM',
    'PITTEPERK',
    'PLAAT',
    'PLAATSLUIS',
    'PLAGGENBORG',
    'PLAK',
    'PLAKKEBORD',
    'PLANKENDORP',
    'PLANKETENT',
    'PLANTAGE',
    'PLANTAGE CENTRUM',
    'PLASMOLEN',
    'PLATVELD',
    'PLEIN',
    'POEDEROIJEN',
    'POEDEROIJENSEHOEK',
    'POELDIJK',
    'POELDONK',
    'POL',
    'POLEN',
    'POLLE',
    'POLSBROEK',
    'POLSBROEKERDAM',
    'POLSDONKEN',
    'PONTE',
    'PONTE AVANCE',
    'PONTE AVANCÉ',
    'POONHAVEN',
    'POORTUGAAL',
    'POORTVLIET',
    'POPPENDAMME',
    'POPPENHUIZEN',
    'POPPENHUZEN',
    'POPPENWIER',
    'PORTENGEN',
    'PORTENGENSE BRUG',
    'POSTERENK',
    'POSTERHOLT',
    'POSTHOORN',
    'POSTHORN',
    'POTHOEK',
    'PRICKART',
    'PRINSENBEEK',
    'PRINSENKAMP',
    'PUIFLIJK',
    'PUNTHORST',
    'PURMER',
    'PURMERBUURT',
    'PURMEREND',
    'PURMERLAND',
    'PUTBROEK',
    'PUTH',
    'PUTSELAAR',
    'PUTTE',
    'PUTTEN',
    'PUTTERSHOEK',
    'PYRAMIDE',
    'QUATRE BRAS',
    'QUATREBRAS',
    'QUIRIJNSTOK',
    'RAAIEIND',
    'RAAKEIND',
    'RAALTE',
    'RAAM',
    'RAAMBERG',
    'RAAMSDONK',
    'RAAMSDONKSVEER',
    'RAAR',
    'RAARD',
    'RAAYEN',
    'RADEWIJK',
    'RADIO KOOTWIJK',
    'RAERD',
    'RAFELDER',
    'RAKENS',
    'RAKT',
    'RANDE',
    'RANDENBURG',
    'RANDWIJK',
    'RANSDAAL',
    'RANSDORP',
    'RANUM',
    'RAREN',
    'RASQUERT',
    'RAVENSGAT',
    'RAVENSTEIN',
    'RAVENSWAAIJ',
    'RAVENSWALD',
    'RAVENSWOUD',
    'RAVENSWÂLD',
    'READTSJERK',
    'REAHEL',
    'REAHUS',
    'REAHÛS',
    'REASKUORRE',
    'RECHTEREN',
    'RECTUM',
    'REDUZUM',
    'REEDIJK',
    'REEK',
    'REETH',
    'REEUWIJK',
    'REEUWIJK BRUG',
    'REEUWIJK DORP',
    'REEUWIJKSE BRUG',
    'REEUWIJKSEBRUG',
    'REIDSWAL',
    'REIDSWÂL',
    'REIJERSCOP',
    'REIJMERSTOK',
    'REITSUM',
    'REKKEN',
    'REMMERDEN',
    'REMSWERD',
    'REN',
    'RENESSE',
    'RENKUM',
    'RENNEBORG',
    'RENSWOUDE',
    'RESPELHOEK',
    'RESSEN',
    'RETERSBEEK',
    'RETH',
    'RETRANCHEMENT',
    'REUSEL',
    'REUTH',
    'REUTJE',
    'REUTUM',
    'REUVER',
    'REUZENHOEK',
    'REWERD',
    'REWERT',
    'RHA',
    'RHAAN',
    'RHEDEN',
    'RHEDERBRUG',
    'RHEDERVELD',
    'RHEE',
    'RHEEBRUGGEN',
    'RHEEVELD',
    'RHEEZE',
    'RHEEZERVEEN',
    'RHENEN',
    'RHENOY',
    'RHIENDEREN',
    'RHOON',
    'RIDDERBUURT',
    'RIDDERKERK',
    'RIE',
    'RIED',
    'RIEL',
    'RIEN',
    'RIETBROEK',
    'RIETHORST',
    'RIETHOVEN',
    'RIETMOLEN',
    'RIETVELD',
    'RIETVEN',
    'RIIS',
    'RIJCKHOLT',
    'RIJEN',
    'RIJKEBUURT',
    'RIJKEL',
    'RIJKERBEEK',
    'RIJKEVOORT',
    'RIJKEVOORT DE WALSERT',
    'RIJKSDORP',
    'RIJNSATERWOUDE',
    'RIJNSBURG',
    'RIJPELBERG',
    'RIJPERKERK',
    'RIJPWETERING',
    'RIJS',
    'RIJSBERGEN',
    'RIJSBERKAMPEN',
    'RIJSDAM',
    'RIJSENHOUT',
    'RIJSOORD',
    'RIJSSEN',
    'RIJSWIJK',
    'RIJT',
    'RIJTSETERP',
    'RILLAND',
    'RIMBURG',
    'RIMPELT',
    'RINKESFORT',
    'RINKVELD',
    'RINSUMAGEAST',
    'RINSUMAGEEST',
    'RITH',
    'RITSUMASYL',
    'RITSUMAZIJL',
    'RITTHEM',
    'ROCKANJE',
    'RODE SLUIS',
    'RODEN',
    'RODERESCH',
    'RODERWOLDE',
    'ROEBOLLIGEHOEK',
    'ROEKEBOSCH',
    'ROEKEL',
    'ROELAGE',
    'ROELOFARENDSVEEN',
    'ROELSHOEK',
    'ROERMOND',
    'ROEVEN',
    'ROGAT',
    'ROGGEL',
    'ROGGELSEDIJK',
    'ROHEL',
    'ROLAF',
    'ROLDE',
    'ROLIGT',
    'ROLLECATE',
    'ROLPAAL',
    'ROME',
    'RONDUITE',
    'RONDVELD',
    'ROODEHAAN',
    'ROODENHOEK',
    'ROODESCHOOL',
    'ROODESCHUUR',
    'ROODEWIJK',
    'ROODHUIS',
    'ROODKERK',
    'ROOND',
    'ROORDAHUIZUM',
    'ROOSBERG',
    'ROOSENDAAL',
    'ROOSTEREN',
    'ROOTH',
    'ROPTASYL',
    'ROPTAZIJL',
    'ROSENGAARDE',
    'ROSKAM',
    'ROSMALEN',
    'ROSSUM',
    'ROSWINKEL',
    'ROTHEM',
    'ROTHENBACH',
    'ROTSTERGAAST',
    'ROTSTERGAST',
    'ROTSTERHAULE',
    'ROTT',
    'ROTTEFALLE',
    'ROTTERDAM',
    'ROTTERDAM ALBRANDSWAARD',
    'ROTTEVALLE',
    'ROTTUM',
    'ROUVEEN',
    'ROVERBERG',
    'ROZENBURG',
    'ROZENDAAL',
    'RUCPHEN',
    'RUGDIJK',
    'RUGEHUZEN',
    'RUIGAHUIZEN',
    'RUIGENHOEK',
    'RUIGEWEIDE',
    'RUIGEZAND',
    'RUIGOORD',
    'RUIMEL',
    'RUINEN',
    'RUINERWEIDE',
    'RUINERWOLD',
    'RUISCHENDEGAT',
    'RUISCHERBRUG',
    'RUITEN',
    'RUITENVEEN',
    'RUKVEN',
    'RUL',
    'RULLEN',
    'RUMPT',
    'RUSVEN',
    'RUTBEEK',
    'RUTTEN',
    'RUURLO',
    'RYPTSJERK',
    'RYSBERKAMP',
    'RYTSETERP',
    'RÛGEHÚZEN',
    'S GRAVELAND',
    'S GRAVENDEEL',
    'S GRAVENHAGE',
    'S GRAVENMOER',
    'S GRAVENMOERSE VAART',
    'S GRAVENPOLDER',
    'S GRAVENWEG',
    'S GRAVENZANDE',
    'S HEER ABTSKERKE',
    'S HEER ARENDSKERKE',
    'S HEER HENDRIKSKINDEREN',
    'S HEERENBERG',
    'S HEERENBROEK',
    'S HEERENHOEK',
    'S HERTOGENBOSCH',
    'S MOLENAARSBUURT',
    'SAAKSUM',
    'SAASVELD',
    'SAAXUMHUIZEN',
    'SALVERD',
    'SALVERT',
    'SAMBEEK',
    'SANBULTEN',
    'SANDEBUUR',
    'SANDFIRDEN',
    'SANFURD',
    'SANHUZEN',
    'SANTFORT',
    'SANTPOORT NOORD',
    'SANTPOORT ZUID',
    'SAPPEMEER',
    'SAS VAN GENT',
    'SASPUT',
    'SASSENHEIM',
    'SAUWERD',
    'SCHAAPBULTEN',
    'SCHAAPHOK',
    'SCHAAPSBRUG',
    'SCHAARSBERGEN',
    'SCHADEWIJK',
    'SCHADIJK',
    'SCHADRON',
    'SCHAESBERG',
    'SCHAFELT',
    'SCHAFFERDEN',
    'SCHAFT',
    'SCHAGEN',
    'SCHAGERBRUG',
    'SCHAIJK',
    'SCHALKHAAR',
    'SCHALKWIJK',
    'SCHALSUM',
    'SCHALUINEN',
    'SCHANDELO',
    'SCHANS',
    'SCHAPENBOUT',
    'SCHAPERSHOEK',
    'SCHARDAM',
    'SCHARENDIJKE',
    'SCHARL',
    'SCHARMER',
    'SCHARNEBUREN',
    'SCHARNEGOUTUM',
    'SCHARSTERBRUG',
    'SCHARWOUDE',
    'SCHAVEREN',
    'SCHEEMDA',
    'SCHEEMDERMEER',
    'SCHEEMDERZWAAG',
    'SCHEENDIJK',
    'SCHEEPSTAL',
    'SCHEERWOLDE',
    'SCHEIDE',
    'SCHELDEVAARTSHOEK',
    'SCHELFHORST',
    'SCHELLACH',
    'SCHELLINGWOUDE',
    'SCHELLINKHOUT',
    'SCHELLUINEN',
    'SCHELM',
    'SCHENKELDIJK',
    'SCHEPENDOM',
    'SCHERMERHORN',
    'SCHERPBIER',
    'SCHERPENERING',
    'SCHERPENISSE',
    'SCHERPENZEEL',
    'SCHETTENS',
    'SCHEULDER',
    'SCHEY',
    'SCHIEDAM',
    'SCHIERMONNIKOOG',
    'SCHIETECOVEN',
    'SCHIEVEN',
    'SCHIJF',
    'SCHIJNDEL',
    'SCHILBERG',
    'SCHILDWOLDE',
    'SCHILLAARD',
    'SCHILLERSHEIDE',
    'SCHILLIGEHAM',
    'SCHIMMELARIJ',
    'SCHIMMERT',
    'SCHIN OP GEUL',
    'SCHINGEN',
    'SCHINNEN',
    'SCHINVELD',
    'SCHIPBORG',
    'SCHIPHOL',
    'SCHIPHOL RIJK',
    'SCHIPLUIDEN',
    'SCHIPPERSKERK',
    'SCHOELIEBERG',
    'SCHOKLAND',
    'SCHOOLBUURT',
    'SCHOONBRON',
    'SCHOONDIJKE',
    'SCHOONDORP',
    'SCHOONEBEEK',
    'SCHOONENBURG',
    'SCHOONHOVEN',
    'SCHOONLOO',
    'SCHOONOORD',
    'SCHOONOUWEN',
    'SCHOONREWOERD',
    'SCHOOR',
    'SCHOORDIJK',
    'SCHOORL',
    'SCHOORLDAM',
    'SCHOORSTRAAT',
    'SCHOORVELD',
    'SCHOOT',
    'SCHORE',
    'SCHOREBRUG',
    'SCHOTERZIJL',
    'SCHOTSHEUVEL',
    'SCHOTTERSHUIZEN',
    'SCHOUW',
    'SCHOUWEN',
    'SCHOUWERZIJL',
    'SCHRAARD',
    'SCHRAPVEEN',
    'SCHREIERSWIJK',
    'SCHRINS',
    'SCHUDDEBEURS',
    'SCHUILENBURG',
    'SCHUINESLOOT',
    'SCHURENBERG',
    'SCHURING',
    'SCHUTSBOOM',
    'SCHUTWIJK',
    'SCHUWACHT',
    'SCHWEIBERG',
    'SEBALDEBUREN',
    'SEERIJP',
    'SEERYP',
    'SEISBIERRUM',
    'SELLINGEN',
    'SELLINGERBEETSE',
    'SELMIEN',
    'SELWERD',
    'SENGELSBROEK',
    'SEROOSKERKE',
    'SETERS',
    'SEVENUM',
    'SEXBIERUM',
    'SIBBE',
    'SIBCULO',
    'SIBERIE',
    'SIBERIË',
    'SIBRANDABUORREN',
    'SIBRANDAHUS',
    'SIBRANDAHÛS',
    'SIDDEBUREN',
    'SIEBENGEWALD',
    'SIEGERSWOUDE',
    'SIGERSWALD',
    'SIGERSWÂLD',
    'SIJBEKARSPEL',
    'SIJBRANDAHUIS',
    'SILVOLDE',
    'SIMONSHAVEN',
    'SIMPELVELD',
    'SINDEREN',
    'SINOUTSKERKE',
    'SINSELBEEK',
    'SINT AGATHA',
    'SINT ANDRIES',
    'SINT ANNA TER MUIDEN',
    'SINT ANNALAND',
    'SINT ANNE',
    'SINT ANNEN',
    'SINT ANNERHUISJES',
    'SINT ANTHONIEPOLDER',
    'SINT ANTHONIS',
    'SINT ANTONIUSBANK',
    'SINT GEERTRUID',
    'SINT HUBERT',
    'SINT ISIDORUSHOEVE',
    'SINT JABIK',
    'SINT JANSGEA',
    'SINT JANSKERKE',
    'SINT JANSKLOOSTER',
    'SINT JANSTEEN',
    'SINT JOOST',
    'SINT KRUIS',
    'SINT LAURENS',
    'SINT MAARTEN',
    'SINT MAARTENSBRUG',
    'SINT MAARTENSDIJK',
    'SINT MAARTENSVLOTBRUG',
    'SINT MAARTENSZEE',
    'SINT MICHIELSGESTEL',
    'SINT NICOLAASGA',
    'SINT NYK',
    'SINT ODILIENBERG',
    'SINT ODILIËNBERG',
    'SINT OEDENRODE',
    'SINT PANCRAS',
    'SINT PHILIPSLAND',
    'SINT VITUSHOLT',
    'SINTJOHANNESGA',
    'SION',
    'SIRJANSLAND',
    'SITTARD',
    'SJUNGADIJK',
    'SJUNGADYK',
    'SKALSUM',
    'SKARL',
    'SKARSTERBREGE',
    'SKARSTERBRÊGE',
    'SKEARNEGOUTUM',
    'SKERPENSEEL',
    'SKETTENS',
    'SKIERMUNTSEACH',
    'SKIERMÛNTSEACH',
    'SKILLAERD',
    'SKINGEN',
    'SKOAR',
    'SKOATTERSYL',
    'SKOU',
    'SKRAARD',
    'SKRINS',
    'SKULENBOARCH',
    'SKUZUM',
    'SKYLDUM',
    'SKÛLENBOARCH',
    'SLABROEK',
    'SLAGHAREN',
    'SLAPERSTIL',
    'SLAPPETERP',
    'SLEAT',
    'SLEEBURG',
    'SLEEN',
    'SLEEUWIJK',
    'SLEGGE',
    'SLEK',
    'SLENAKEN',
    'SLICHTENHORST',
    'SLIEDRECHT',
    'SLIFFERT',
    'SLIJK EWIJK',
    'SLIJKENBURG',
    'SLIJKPLAAT',
    'SLIJKWELL',
    'SLIKENBOARCH',
    'SLIKKENBURG',
    'SLIKKENDAM',
    'SLINGENBERG',
    'SLOCHTEREN',
    'SLOOT',
    'SLOOTDORP',
    'SLOTEN',
    'SLUIPWIJK',
    'SLUIS',
    'SLUIS 13',
    'SLUIS 5',
    'SLUIS 6',
    'SLUIS 7',
    'SLUIS DE PIET',
    'SLUISKIL',
    'SMAKT',
    'SMAL',
    'SMALBROEK',
    'SMALLE EE',
    'SMALLEBRUGGE',
    'SMEDEKENSBRUGGE',
    'SMEERLING',
    'SMELBREGE',
    'SMELBRÊGE',
    'SMELE',
    'SMELLE IE',
    'SMIDSTRAAT',
    'SMILDE',
    'SMITSHOEK',
    'SNAKKERBUORREN',
    'SNAKKERBUREN',
    'SNEEK',
    'SNEIDERSHOEK',
    'SNELLEVELD',
    'SNELREWAARD',
    'SNEPSEIND',
    'SNIJDERS CHAAM',
    'SNIJDERSBERG',
    'SNIKSWEACH',
    'SNIKZWAAG',
    'SNITS',
    'SNODENHOEK',
    'SNORRENHOEF',
    'SOARREMOARRE',
    'SOERENDONK',
    'SOEST',
    'SOESTDIJK',
    'SOESTDUINEN',
    'SOESTERBERG',
    'SOETERBEEK',
    'SOLWERD',
    'SOMEREN',
    'SOMEREN EIND',
    'SOMEREN HEIDE',
    'SOMMELSDIJK',
    'SON',
    'SON EN BREUGEL',
    'SONDEL',
    'SONNEGA',
    'SONNEGEA',
    'SONNIUSWIJK',
    'SOPSUM',
    'SORREMORRE',
    'SPAANRIJT',
    'SPAANSEHOEK',
    'SPAANSHUISKEN',
    'SPAARNDAM',
    'SPAARNDAM GEM HAARLEM',
    'SPANBROEK',
    'SPANGA',
    'SPANKEREN',
    'SPANNENBURCH',
    'SPANNENBURG',
    'SPANNUM',
    'SPARJEBIRD',
    'SPARJEBURD',
    'SPAUBEEK',
    'SPEARS',
    'SPEERS',
    'SPEKHOEK',
    'SPEKKLEF',
    'SPEKT',
    'SPENGEN',
    'SPEULD',
    'SPEURGT',
    'SPIER',
    'SPIERDIJK',
    'SPIESBERG',
    'SPIJK',
    'SPIJKENISSE',
    'SPIJKERBOOR',
    'SPIK',
    'SPINOLABERG',
    'SPITSBERGEN',
    'SPITSENDIJK',
    'SPOELWIJK',
    'SPONTURFWIJK',
    'SPOOLDE',
    'SPOORBUURT',
    'SPOORDONK',
    'SPRANG',
    'SPRANG CAPELLE',
    'SPRANGSEVAART',
    'SPRONG',
    'SPRUNDEL',
    'SPUI',
    'SPURKT',
    'ST ANNAPAROCHIE',
    'ST JACOBIPAROCHIE',
    'ST WILLEBRORD',
    'STAD AAN T HARINGVLIET',
    'STAD VAN GERWEN',
    'STADSE DIJK',
    'STADSKANAAL',
    'STADTERIJ',
    'STAKENBORG',
    'STAMPERSGAT',
    'STANDDAARBUITEN',
    'STAPHORST',
    'STARNMEER',
    'STARTENHUIZEN',
    'STARTWIJK',
    'STARUM',
    'STATENBOOM',
    'STATENDAM',
    'STATIONSBUURT',
    'STAVENISSE',
    'STAVERDEN',
    'STAVOREN',
    'STEDUM',
    'STEEG',
    'STEELHOVEN',
    'STEENBERGEN',
    'STEENDAM',
    'STEENDEREN',
    'STEENENKAMER',
    'STEENENKRUIS',
    'STEENHOVEN',
    'STEENOVEN',
    'STEENOVENS',
    'STEENPAAL',
    'STEENPLAATS',
    'STEENSEL',
    'STEENVAK',
    'STEENWIJK',
    'STEENWIJKERWOLD',
    'STEENWIJKSMOER',
    'STEGEN',
    'STEGEREN',
    'STEGERVELD',
    'STEGGERDA',
    'STEIN',
    'STELLENDAM',
    'STENENHEUL',
    'STEPELO',
    'STERKENBURG',
    'STERKSEL',
    'STERRESCHANS',
    'STEURGAT',
    'STEVENSBEEK',
    'STEVENSWEERT',
    'STEVERT',
    'STEYL',
    'STIELTJESKANAAL',
    'STIEM',
    'STIENFEK',
    'STIENS',
    'STIPDONK',
    'STIPHOUT',
    'STITSWERD',
    'STOBBEN',
    'STOKHEM',
    'STOKKELAARSBRUG',
    'STOKKELEN',
    'STOKKUM',
    'STOKSKE',
    'STOKT',
    'STOLPEN',
    'STOLPERVLOTBRUG',
    'STOLWIJK',
    'STOLWIJKERSLUIS',
    'STOMMEVELD',
    'STOMPETOREN',
    'STOMPWIJK',
    'STOOF',
    'STOOTSHORN',
    'STOPPELDIJKVEER',
    'STORK',
    'STOUTENBURG',
    'STOUTENBURG NOORD',
    'STOX',
    'STRAAT',
    'STRABRECHT',
    'STRAMPROY',
    'STRAND',
    'STRATEN',
    'STRATERIS',
    'STREEFKERK',
    'STREEK',
    'STREPEN',
    'STREUKEL',
    'STRIJBEEK',
    'STRIJEN',
    'STRIJENHAM',
    'STRIJENSAS',
    'STRIJP',
    'STRIKBERG',
    'STROBOS',
    'STROE',
    'STROET',
    'STROOBOS',
    'STROODORP',
    'STROODORPE',
    'STROOIENDORP',
    'STROOIENSTAD',
    'STROOPUIT',
    'STRUBBEN',
    'STRUCHT',
    'STRUIKBERG',
    'STRYPE',
    'STUIFAKKER',
    'STUIFZAND',
    'STUIVEZAND',
    'STYNSGEA',
    'SUAMEER',
    'SUAMEERDERHEIDE',
    'SUAWOUDE',
    'SUDHORN',
    'SUMAR',
    'SUMARREHEIDE',
    'SURCH',
    'SURHUISTERVEEN',
    'SURHUIZUM',
    'SURHUIZUMER MIEDEN',
    'SURHUSTERFEAN',
    'SURHUZUM',
    'SURHUZUMER MIEDEN',
    'SURHÚSTERFEAN',
    'SUSTEREN',
    'SUTTUM',
    'SUWALD',
    'SUWÂLD',
    'SWAENWERT',
    'SWALMEN',
    'SWARTBROEK',
    'SWARTE HAAN',
    'SWEAGERBOSK',
    'SWEIKHUIZEN',
    'SWEINS',
    'SWICHUM',
    'SWIER',
    'SWIFTERBANT',
    'SWOLGEN',
    'SYTEBUORREN',
    'SYTHUIZEN',
    'SYTHUZEN',
    'SÂNBULTEN',
    'SÂNFURD',
    'SÂNHUZEN',
    'SÚDHORN',
    'T BERGJE',
    'T BUURTJE',
    'T COLL',
    'T EIND',
    'T GOY',
    'T HAANTJE',
    'T HARDE',
    'T HAZELEGER',
    'T HEECHHOUT',
    'T HEESKE',
    'T HERSELT',
    'T HOEKJE',
    'T HOEKSKE',
    'T HOF',
    'T JAGERTJE',
    'T KIP',
    'T KRET',
    'T LAAR',
    'T LAGE VAN DE WEG',
    'T LEUKEN',
    'T LOO',
    'T LOO OLDEBROEK',
    'T MARKTJE',
    'T NOORDEN',
    'T OEVER',
    'T ROLDER',
    'T ROOTH',
    'T SCHOOR',
    'T STORT',
    'T VEEN',
    'T VELD',
    'T VEN',
    'T VILLEKEN',
    'T VLAANDERTJE',
    'T VLOT',
    'T VOSSENEIND',
    'T WAAR',
    'T WINKEL',
    'T WOUD',
    'T WOUDT',
    'T WYTFEAN',
    'T ZAND',
    'T ZANDSTERVOORWERK',
    'T ZANDT',
    'TAARLO',
    'TAPPERSHEUL',
    'TASDIJK',
    'TEARNS',
    'TECKOP',
    'TEEFFELEN',
    'TEERNS',
    'TEERSDIJK',
    'TEGELEN',
    'TEIJEBUREN',
    'TEIJLINGEN',
    'TELGT',
    'TEMPEL',
    'TEN ARLO',
    'TEN BOER',
    'TEN HAVE',
    'TEN POST',
    'TEN VORSEL',
    'TER AALST',
    'TER AAR',
    'TER AARD',
    'TER APEL',
    'TER APELKANAAL',
    'TER BORG',
    'TER HAAR',
    'TER HEIJDE',
    'TER HORST',
    'TER IDZARD',
    'TER LAAN',
    'TER LUCHT',
    'TER MAARSCH',
    'TER WALSLAGE',
    'TER WISCH',
    'TER WUPPING',
    'TERBAND',
    'TERBANT',
    'TERBLIJT',
    'TERBORG',
    'TERBREGGE',
    'TERDIEK',
    'TEREYKEN',
    'TERGRACHT',
    'TERGREFT',
    'TERGRÊFT',
    'TERHAGEN',
    'TERHEIJDEN',
    'TERHEIJL',
    'TERHERNE',
    'TERHOFSTEDE',
    'TERHOLE',
    'TERHORNE',
    'TERHORST',
    'TERIDZERT',
    'TERKAPLE',
    'TERLET',
    'TERLINDEN',
    'TERMAAR',
    'TERMOORS',
    'TERMUNTEN',
    'TERMUNTERZIJL',
    'TERNAARD',
    'TERNEUZEN',
    'TEROELE',
    'TEROVER',
    'TERPOORTEN',
    'TERSCHUUR',
    'TERSOAL',
    'TERSTRATEN',
    'TERVATEN',
    'TERVOORST',
    'TERVOORT',
    'TERWISPEL',
    'TERWISSCHA',
    'TERWOLDE',
    'TERZIET',
    'TETERINGEN',
    'TEUGE',
    'TEYEBUORREN',
    'THEETUIN',
    'THEMAAT',
    'THESINGE',
    'THOLEN',
    'THORN',
    'THULL',
    'THUSERHOF',
    'TIBMA',
    'TICHELWURK',
    'TIEL',
    'TIELSE HOEVE',
    'TIENDEVEEN',
    'TIENGEBODEN',
    'TIENGEMETEN',
    'TIENHOVEN',
    'TIENHOVEN AAN DE LEK',
    'TIENRAY',
    'TIETJERK',
    'TIGGELT',
    'TIGGELTSCHEBERG',
    'TIJNJE',
    'TILBUORREN',
    'TILBUREN',
    'TILBURG',
    'TILLIGTE',
    'TIMMEREIND',
    'TINALLINGE',
    'TINTE',
    'TIRNS',
    'TJAARD',
    'TJABBESSTREEK',
    'TJALHUIZUM',
    'TJALLEBERD',
    'TJAMSWEER',
    'TJEINTGUM',
    'TJEPPENBOER',
    'TJERKGAAST',
    'TJERKWERD',
    'TJOENE',
    'TJUCHEM',
    'TOLBERT',
    'TOLDIJK',
    'TOLKAMER',
    'TOLLEBEEK',
    'TOMMEL',
    'TONDEN',
    'TONGEREN',
    'TONGERLO',
    'TONNEKREEK',
    'TONSEL',
    'TOOM',
    'TOORNWERD',
    'TOPPENHUZEN',
    'TOPWEER',
    'TORENVEEN',
    'TOTERFOUT',
    'TOVEN',
    'TRAGEL',
    'TRANENDAL',
    'TREGELAAR',
    'TRENT',
    'TRICHT',
    'TRIEMEN',
    'TRIJEBOEREHUZEN',
    'TRIJEHUZEN',
    'TRIMPERT',
    'TRINTELEN',
    'TRIPSCOMPAGNIE',
    'TRITSUM',
    'TRITZUM',
    'TRONDE',
    'TROPHORNE',
    'TRUTJESHOEK',
    'TSIENZERBUORREN',
    'TSJALBERT',
    'TSJALHUZUM',
    'TSJEINTGUM',
    'TSJERKEBUORREN',
    'TSJERKGAAST',
    'TSJERKWERT',
    'TSJOM',
    'TSJUMMEARUM',
    'TUBBERGEN',
    'TUIL',
    'TUINDORP',
    'TUITJENHORN',
    'TUK',
    'TULL EN T WAAL',
    'TUNGELROY',
    'TURKEIJE',
    'TURKEYE',
    'TURNS',
    'TUSSCHEN DE BRUGGEN',
    'TUSSCHENLOEGEN',
    'TUSSENKLAPPEN',
    'TUSSENLANEN',
    'TUSVELD',
    'TUUTHEES',
    'TWEEDE DWARSDIEP',
    'TWEEDE TOL',
    'TWEEHUIZEN',
    'TWEESLUIZEN',
    'TWEKKELO',
    'TWELLINGEA',
    'TWELLO',
    'TWIJZEL',
    'TWIJZELERHEIDE',
    'TWISK',
    'TWIZEL',
    'TWIZELERHEIDE',
    'TYNAARLO',
    'TYTSJERK',
    'TZUM',
    'TZUMMARUM',
    'UBACH OVER WORMS',
    'UBACHSBERG',
    'UBBENA',
    'UBBERGEN',
    'UBROEK',
    'UDDEL',
    'UDEN',
    'UDENHOUT',
    'UFFELSEN',
    'UFFELTE',
    'UGCHELEN',
    'UILESPRONG',
    'UITDAM',
    'UITEINDE',
    'UITERBUREN',
    'UITGEEST',
    'UITHOORN',
    'UITHUIZEN',
    'UITHUIZERMEEDEN',
    'UITWEG',
    'UITWELLINGERGA',
    'UITWIERDE',
    'UITWIJK',
    'ULESTRATEN',
    'ULFT',
    'ULFTERHOEK',
    'ULICOTEN',
    'ULLINGEN',
    'ULRUM',
    'ULSDA',
    'ULVEND',
    'ULVENHOUT',
    'ULVENHOUT AC',
    'UNGABUURT',
    'UPPEL',
    'URETERP',
    'URK',
    'URKHOVEN',
    'URMOND',
    'URSEM',
    'USQUERT',
    'USSELO',
    'UTRECHT',
    'VAALS',
    'VAARDEBUREN',
    'VAAREIND',
    'VAARLE',
    'VAARS CH E HOEF',
    'VAART',
    'VAARTWIJK',
    'VAASSEN',
    'VAESRADE',
    'VALBURG',
    'VALEISKREEK',
    'VALENBERG',
    'VALKENBURG',
    'VALKENHEIDE',
    'VALKENSWAARD',
    'VALOM',
    'VALSTEEG',
    'VALTHE',
    'VALTHERBLOKKEN',
    'VALTHERMOND',
    'VALTHERMUSSEL',
    'VAN EWIJCKSLUIS',
    'VARIK',
    'VARSEN',
    'VARSSEL',
    'VARSSELDER',
    'VARSSEVELD',
    'VASSE',
    'VEBENABOS',
    'VECHTEN',
    'VEECATEN',
    'VEELE',
    'VEELERVEEN',
    'VEEN',
    'VEENDAM',
    'VEENDIJK',
    'VEENENDAAL',
    'VEENHOF',
    'VEENHUIZEN',
    'VEENHUIZERVELD',
    'VEENINGEN',
    'VEENKLOOSTER',
    'VEENOORD',
    'VEENWOUDEN',
    'VEENWOUDSTERWAL',
    'VEERE',
    'VEERSTE R VELDHUIS',
    'VEESSEN',
    'VEGELINSOARD',
    'VEGELINSOORD',
    'VEGHEL',
    'VELD',
    'VELD OOSTENRIJK',
    'VELDBRAAK',
    'VELDDIJK',
    'VELDDRIEL',
    'VELDEN',
    'VELDHOEK',
    'VELDHOVEN',
    'VELDHUIS',
    'VELDHUIZEN',
    'VELDHUNTEN',
    'VELDSCHUUR',
    'VELDSTREEK',
    'VELDWIJK',
    'VELDZICHT',
    'VELP',
    'VELSEN NOORD',
    'VELSEN ZUID',
    'VELSERBROEK',
    'VELSWIJK',
    'VELUWE',
    'VEMDE',
    'VEN',
    'VEN ZELDERHEIDE',
    'VENBERGEN',
    'VENEBRUGGE',
    'VENEBUREN',
    'VENEIND',
    'VENEKOTEN',
    'VENHORST',
    'VENHUIZEN',
    'VENLO',
    'VENNE',
    'VENRAY',
    'VENWEG',
    'VERGELT',
    'VERHOVEN',
    'VERLOREN HOEK',
    'VERLORENHOEK',
    'VERNHOUT',
    'VESSEM',
    'VESTJENSHOEK',
    'VETHUIZEN',
    'VETTERIK',
    'VEULEN',
    'VIANEN',
    'VIEL',
    'VIERAKKER',
    'VIERBANNEN',
    'VIERHOUTEN',
    'VIERHUIS',
    'VIERHUIZEN',
    'VIERLINGSBEEK',
    'VIERPOLDERS',
    'VIERUITERSTEN',
    'VIERVERLATEN',
    'VIJCIE',
    'VIJFHOEK',
    'VIJFHUIS',
    'VIJFHUIZEN',
    'VIJLEN',
    'VILGERT',
    'VILSTEREN',
    'VILT',
    'VINK',
    'VINKE N KADE',
    'VINKEGA',
    'VINKEL',
    'VINKENBERG',
    'VINKENBROEK',
    'VINKENBUURT',
    'VINKEPAS',
    'VINKEVEEN',
    'VINKWIJK',
    'VISBERG',
    'VISBUURT',
    'VISDONK',
    'VISSCHERSHOEK',
    'VISSER S WEERT',
    'VISSERSBUREN',
    'VISVLIET',
    'VLAARDINGEN',
    'VLAAS',
    'VLAGBERG',
    'VLAGTWEDDE',
    'VLAGTWEDDER VELDHUIS',
    'VLAKE',
    'VLAS',
    'VLEDDER',
    'VLEDDERHUIZEN',
    'VLEDDERVEEN',
    'VLEET',
    'VLENGENDAAL',
    'VLEUTEN',
    'VLIEGERT',
    'VLIEGHUIS',
    'VLIELAND',
    'VLIERDEN',
    'VLIET',
    'VLIJMEN',
    'VLISSINGEN',
    'VLIST',
    'VLODROP',
    'VLOEIEIND',
    'VLOET',
    'VLOOTKANT',
    'VOEDERHEIL',
    'VOERENDAAL',
    'VOGELENZANG',
    'VOGELFORT',
    'VOGELSWERF',
    'VOGELWAARDE',
    'VOGELZANG',
    'VOLCKERDORP',
    'VOLENDAM',
    'VOLKEL',
    'VOLLENHOVE',
    'VOLTHE',
    'VONDELINGENPLAAT',
    'VONDELINGENPLAAT ROTTERDAM',
    'VOORBURG',
    'VOORDELDONK',
    'VOORDIJK',
    'VOOREIND',
    'VOORHOUT',
    'VOORNE',
    'VOORRIJP',
    'VOORSCHOTEN',
    'VOORST',
    'VOORSTE BEERSDONK',
    'VOORSTE BRUG',
    'VOORSTE DIESDONK',
    'VOORSTE HEIKANT',
    'VOORSTERVELD',
    'VOORSTONDEN',
    'VOORT',
    'VOORTEIND',
    'VOORTHUIZEN',
    'VOORTJE',
    'VOORWEG',
    'VORCHTEN',
    'VORDEN',
    'VORST',
    'VORSTENBOSCH',
    'VORTUM MULLEM',
    'VOSBERG',
    'VOSKE',
    'VOSKUIL',
    'VOSKUILEN',
    'VOSSEBELT',
    'VOSSEBERG',
    'VOSSEBUREN',
    'VOSSELEN',
    'VOSSENBERG',
    'VOSSENPELS',
    'VOULWAMES',
    'VRACHELEN',
    'VRAGENDER',
    'VREDENHEIM',
    'VREDEPEEL',
    'VREELAND',
    'VREEWIJK',
    'VRIES',
    'VRIESCHELOO',
    'VRIEZEKOOP',
    'VRIEZENVEEN',
    'VRIJ',
    'VRIJHOEVE',
    'VRIJHOEVEN',
    'VRILKHOVEN',
    'VROELEN',
    'VROENHOUT',
    'VROOMSHOOP',
    'VROUWBUURTSTERMOLEN',
    'VROUWENAKKER',
    'VROUWENPAROCHIE',
    'VROUWENPOLDER',
    'VROUWENTROOST',
    'VUCHTSCHOOT',
    'VUGHT',
    'VUILE RIETE',
    'VUILENDAM',
    'VUILPAN',
    'VUREN',
    'VÖLCKERDORP',
    'WAAKSENS',
    'WAAL',
    'WAALBROEK',
    'WAALRE',
    'WAALWIJK',
    'WAANSKINDEREN',
    'WAARDE',
    'WAARDENBURG',
    'WAARDER',
    'WAARDHUIZEN',
    'WAARLAND',
    'WAATSKAMP',
    'WAAXENS',
    'WACHTUM',
    'WADDINXVEEN',
    'WADENOIJEN',
    'WADWAY',
    'WADWERD',
    'WAGENBERG',
    'WAGENBORGEN',
    'WAGENINGEN',
    'WAHLWILLER',
    'WAIJE',
    'WALDERVEEN',
    'WALDSEIN',
    'WALEM',
    'WALIK',
    'WALS',
    'WALSERT',
    'WALSOORDEN',
    'WALTERSWALD',
    'WAMBERG',
    'WAMEL',
    'WAMMERT',
    'WANNEPERVEEN',
    'WANROIJ',
    'WANSSUM',
    'WANSWERD',
    'WANSWERT',
    'WAPENVELD',
    'WAPSE',
    'WAPSERVEEN',
    'WAR',
    'WARDER',
    'WARFFUM',
    'WARFHUIZEN',
    'WARFSTERMOLEN',
    'WARFSTERMUNE',
    'WARFSTERMÛNE',
    'WARGA',
    'WARKUM',
    'WARM',
    'WARMENHUIZEN',
    'WARMOND',
    'WARNIAHUIZEN',
    'WARNS',
    'WARNSVELD',
    'WARSTIENS',
    'WARTEN',
    'WARTENA',
    'WASKEMAR',
    'WASKEMEER',
    'WASPIK',
    'WASPIK ZUID',
    'WASSENAAR',
    'WASSINKBRINK',
    'WATEREN',
    'WATERGANG',
    'WATERHOEK',
    'WATERHUIZEN',
    'WATERINGEN',
    'WATERKANT',
    'WATERLANDKERKJE',
    'WATEROP',
    'WATERSTRAAT',
    'WATERVAL',
    'WAVER',
    'WAVERVEEN',
    'WEAKENS',
    'WEDDE',
    'WEDDERHEIDE',
    'WEDDERVEER',
    'WEEBOSCH',
    'WEEG',
    'WEENDE',
    'WEERD',
    'WEERDINGE',
    'WEERESTEIN',
    'WEERSELO',
    'WEERT',
    'WEERWILLE',
    'WEESP',
    'WEG',
    'WEHE DEN HOORN',
    'WEHL',
    'WEIDUM',
    'WEIJERSWOLD',
    'WEIJLAND',
    'WEIJPOORT',
    'WEILENSEIND',
    'WEIMEREN',
    'WEINTERPFALLAAT',
    'WEIPOORT',
    'WEITE',
    'WEITEMANSLANDEN',
    'WEITEVEEN',
    'WEKEROM',
    'WELBERG',
    'WELEVELD',
    'WELL',
    'WELLERLOOI',
    'WELLSEIND',
    'WELSRIJP',
    'WELSUM',
    'WELSUMERVELD',
    'WELY',
    'WEMELDINGE',
    'WEMMENHOVE',
    'WENUM',
    'WENUM WIESEL',
    'WEPER',
    'WEPERPOLDER',
    'WERCHEREN',
    'WERENDIJKE',
    'WERGEA',
    'WERKENDAM',
    'WERKHOVEN',
    'WERNHOUT',
    'WERNHOUTSBURG',
    'WERVELD',
    'WERVEN',
    'WERVERSHOOF',
    'WESCH',
    'WESEPE',
    'WESSEM',
    'WESSINGE',
    'WESSINGHUIZEN',
    'WESSINGTANGE',
    'WEST AAN ZEE',
    'WEST GEESTEREN',
    'WEST GRAFTDIJK',
    'WEST OAN SEE',
    'WEST SOUBURG',
    'WEST TERSCHELLING',
    'WESTBEEMSTER',
    'WESTBROEK',
    'WESTDIJK',
    'WESTDORP',
    'WESTDORPE',
    'WESTEIND',
    'WESTEINDE',
    'WESTELBEERS',
    'WESTENDORP',
    'WESTENENG',
    'WESTENESCH',
    'WESTENSCHOUWEN',
    'WESTERBEEK',
    'WESTERBORK',
    'WESTERBROEK',
    'WESTERBUORREN',
    'WESTERBUREN',
    'WESTERDIJKSHORN',
    'WESTEREIN',
    'WESTEREIN HARICH',
    'WESTEREMDEN',
    'WESTERGEAST',
    'WESTERGEEST',
    'WESTERHAAR VRIEZENVEENSEWIJK',
    'WESTERHORN',
    'WESTERHOVEN',
    'WESTERKLOOSTER',
    'WESTERLAND',
    'WESTERLEE',
    'WESTERNIELAND',
    'WESTERNIJTJERK',
    'WESTERNIJTSJERK',
    'WESTERSE BOS',
    'WESTERVELDE',
    'WESTERVOORT',
    'WESTERWIJK',
    'WESTERWIJTWERD',
    'WESTERZAND',
    'WESTHEM',
    'WESTHIM',
    'WESTHOEK',
    'WESTKAPELLE',
    'WESTKERKE',
    'WESTKNOLLENDAM',
    'WESTLAREN',
    'WESTMAAS',
    'WESTRIK',
    'WESTWOUD',
    'WESTZAAN',
    'WETERING',
    'WETERINGBRUG',
    'WETSENS',
    'WETSINGE',
    'WETZENS',
    'WEURT',
    'WEUSTENRADE',
    'WEVERSHOEK',
    'WEVERSLO',
    'WEVERWIJK',
    'WEZEL',
    'WEZEP',
    'WEZUP',
    'WEZUPERBRUG',
    'WICHMOND',
    'WIE',
    'WIEKEN',
    'WIEKSLOOT',
    'WIELDER',
    'WIELDRECHT',
    'WIELER',
    'WIENE',
    'WIER',
    'WIERDEN',
    'WIERHUIZEN',
    'WIERINGERWAARD',
    'WIERINGERWERF',
    'WIERREN',
    'WIERUM',
    'WIERUMERSCHOUW',
    'WIESEL',
    'WIEUWENS',
    'WIEUWERD',
    'WIJCHEN',
    'WIJCKEL',
    'WIJDENES',
    'WIJDEWORMER',
    'WIJGEEST',
    'WIJHE',
    'WIJK AAN ZEE',
    'WIJK BIJ DUURSTEDE',
    'WIJK EN AALBURG',
    'WIJLRE',
    'WIJNALDUM',
    'WIJNANDSRADE',
    'WIJNBERGEN',
    'WIJNGAARDEN',
    'WIJNJETERPVERLAAT',
    'WIJNJEWOUDE',
    'WIJNS',
    'WIJSTER',
    'WIJTGAARD',
    'WIJTHMEN',
    'WIJZEND',
    'WIKEL',
    'WILBERTOORD',
    'WILDENBORCH',
    'WILDEPLAATS',
    'WILDERHOF',
    'WILDERT',
    'WILDERVANK',
    'WILDERVANKSTERDALLEN',
    'WILHELMINADORP',
    'WILHELMINAOORD',
    'WILHELMSOORD',
    'WILLEBRORDUSHOEK',
    'WILLEMSDORP',
    'WILLEMSOORD',
    'WILLEMSTAD',
    'WILLESKOP',
    'WILLIGE LANGERAK',
    'WILNIS',
    'WILP',
    'WILSUM',
    'WILSVEEN',
    'WINAEM',
    'WINDE',
    'WINDESHEIM',
    'WINDRAAK',
    'WINKEL',
    'WINKELSHOEK',
    'WINKELSTRAAT',
    'WINNEWEER',
    'WINSCHOTEN',
    'WINSCHOTERHOOGEBRUG',
    'WINSSEN',
    'WINSUM',
    'WINTELRE',
    'WINTERSWIJK',
    'WINTERSWIJK BRINKHEURNE',
    'WINTERSWIJK CORLE',
    'WINTERSWIJK HENXEL',
    'WINTERSWIJK HUPPEL',
    'WINTERSWIJK KOTTEN',
    'WINTERSWIJK MEDDO',
    'WINTERSWIJK MISTE',
    'WINTERSWIJK RATUM',
    'WINTERSWIJK WOOLD',
    'WINTHAGEN',
    'WIRDUM',
    'WIRDUMERDRAAI',
    'WISBROEK',
    'WISSEKERKE',
    'WISSEL',
    'WISSENKERKE',
    'WITDONK',
    'WITHAREN',
    'WITHUIS',
    'WITMAN',
    'WITMARSUM',
    'WITRIJT',
    'WITTE PAARDEN',
    'WITTEBRINK',
    'WITTELTE',
    'WITTEM',
    'WITTEN',
    'WITTEVEEN',
    'WITTEWIERUM',
    'WITVEEN',
    'WIUWERT',
    'WJELSRYP',
    'WOENSDRECHT',
    'WOERD',
    'WOERDEN',
    'WOERDENSE VERLAAT',
    'WOESTE HOEVE',
    'WOEZIK',
    'WOGNUM',
    'WOLBERT',
    'WOLDENDORP',
    'WOLFERSVEEN',
    'WOLFHAAG',
    'WOLFHAGEN',
    'WOLFHEZE',
    'WOLFSBARGE',
    'WOLFSBOSCH',
    'WOLFSHOEK',
    'WOLFSHUIS',
    'WOLFSWINKEL',
    'WOLLINGBOERMARKE',
    'WOLLINGHUIZEN',
    'WOLPHAARTSDIJK',
    'WOLSUM',
    'WOLTERSUM',
    'WOLVEGA',
    'WOLVEGEA',
    'WOMMELS',
    'WONNEBUREN',
    'WONS',
    'WOORD',
    'WORDRAGEN',
    'WORKUM',
    'WORMER',
    'WORMERVEER',
    'WORSUM',
    'WOUBRUGGE',
    'WOUD',
    'WOUDBLOEM',
    'WOUDENBERG',
    'WOUDRICHEM',
    'WOUDSE DIJK',
    'WOUDSEND',
    'WOUTERSWOUDE',
    'WOUW',
    'WOUWSE HIL',
    'WOUWSE PLANTAGE',
    'WULPENBEK',
    'WUNS',
    'WURDUM',
    'WYNJEWALD',
    'WYNJEWÂLD',
    'WYNS',
    'WYTGAARD',
    'WYTMARSUM',
    'WÂLDSEIN',
    'WÂLTERSWÂLD',
    'WÂNSWERT',
    'WÛNS',
    'YCHTEN',
    'YCHTENBREGE',
    'YCHTENBRÊGE',
    'YDE',
    'YERSEKE',
    'YERSEKENDAM',
    'YMSWALDE',
    'YMSWÂLDE',
    'YNDYK',
    'YPECOLSGA',
    'YPEKOLSGEA',
    'YPELO',
    'YSBRECHTUM',
    'YSSELSTEYN',
    'ZAAMSLAG',
    'ZAAMSLAGVEER',
    'ZAANDAM',
    'ZAANDIJK',
    'ZAARVLAAS',
    'ZALK',
    'ZALNE',
    'ZALNÉ',
    'ZALTBOMMEL',
    'ZAND',
    'ZANDBERG',
    'ZANDBULTEN',
    'ZANDBUREN',
    'ZANDDIJK',
    'ZANDEIND',
    'ZANDEWEER',
    'ZANDFORT',
    'ZANDHEUVEL',
    'ZANDHOEK',
    'ZANDHUIZEN',
    'ZANDKANT',
    'ZANDOERLE',
    'ZANDPLAAT',
    'ZANDPOL',
    'ZANDSTRAAT',
    'ZANDVOORT',
    'ZANDWIJK',
    'ZEDDAM',
    'ZEEDORP',
    'ZEEGAT',
    'ZEEGSE',
    'ZEELAND',
    'ZEELBERG',
    'ZEERIJP',
    'ZEESSE',
    'ZEEWOLDE',
    'ZEGGE',
    'ZEGVELD',
    'ZEIJEN',
    'ZEIJERVEEN',
    'ZEIJERVELD',
    'ZEIST',
    'ZELDAM',
    'ZELDER',
    'ZELDERT',
    'ZELEN',
    'ZELHEM',
    'ZELT',
    'ZENDEREN',
    'ZENNEWIJNEN',
    'ZETHUIS',
    'ZETTEN',
    'ZEVENAAR',
    'ZEVENBERGEN',
    'ZEVENBERGSCHEN HOEK',
    'ZEVENBUURT',
    'ZEVENDER',
    'ZEVENHOVEN',
    'ZEVENHUIS',
    'ZEVENHUIZEN',
    'ZEVENHUTTEN',
    'ZEVENMORGEN',
    'ZIEK',
    'ZIERIKZEE',
    'ZIEUWENT',
    'ZIJDERVELD',
    'ZIJDEWIND',
    'ZIJLDIJK',
    'ZIJP',
    'ZIJPERSLUIS',
    'ZIJTAART',
    'ZINKWEG',
    'ZITTARD',
    'ZOEKE',
    'ZOELEN',
    'ZOELMOND',
    'ZOERTE',
    'ZOETERMEER',
    'ZOETERWOUDE',
    'ZOETERWOUDE DORP',
    'ZOETERWOUDE RIJNDIJK',
    'ZOGGEL',
    'ZOMERDIJK',
    'ZOMERVEN',
    'ZONDVELD',
    'ZONNEMAIRE',
    'ZONNEWIJNEN',
    'ZOOMVLIET',
    'ZORGVLIED',
    'ZOUTELANDE',
    'ZOUTEVEEN',
    'ZOUTKAMP',
    'ZUID BEIJERLAND',
    'ZUID CAROLINA',
    'ZUID SCHARWOUDE',
    'ZUIDBROEK',
    'ZUIDBUURT',
    'ZUIDDORPE',
    'ZUIDEINDE',
    'ZUIDERBUREN',
    'ZUIDERESCH',
    'ZUIDERKOLONIE',
    'ZUIDERMEER',
    'ZUIDEROPGAANDE',
    'ZUIDERVEEN',
    'ZUIDERWOUDE',
    'ZUIDGEEST',
    'ZUIDHO O RN',
    'ZUIDHORN',
    'ZUIDLAARDERVEEN',
    'ZUIDLAND',
    'ZUIDLAREN',
    'ZUIDLOO',
    'ZUIDOOSTBEEMSTER',
    'ZUIDSCHERMER',
    'ZUIDVEEN',
    'ZUIDVELD',
    'ZUIDVELDE',
    'ZUIDWENDING',
    'ZUIDWOLDE',
    'ZUIDZANDE',
    'ZUIDZIJDE',
    'ZUILICHEM',
    'ZUNA',
    'ZUNDERDORP',
    'ZUNDERT',
    'ZURICH',
    'ZUTPHEN',
    'ZUUK',
    'ZUURDIJK',
    'ZWAAG',
    'ZWAAGDIJK',
    'ZWAAGDIJK OOST',
    'ZWAAGDIJK WEST',
    'ZWAAGWESTEINDE',
    'ZWAANENHEIKE',
    'ZWAANSHOEK',
    'ZWAANTJE',
    'ZWAGERBOSCH',
    'ZWAMMERDAM',
    'ZWANEGAT',
    'ZWANENBURG',
    'ZWARTE HAAN',
    'ZWARTE PAARD',
    'ZWARTE RUITER',
    'ZWARTEBROEK',
    'ZWARTEMEER',
    'ZWARTENBERG',
    'ZWARTEWAAL',
    'ZWARTEWATERSKLOOSTER',
    'ZWARTSCHAAP',
    'ZWARTSLUIS',
    'ZWARTSLUISJE',
    'ZWEEKHORST',
    'ZWEELOO',
    'ZWEINS',
    'ZWET',
    'ZWIEP',
    'ZWIGGELTE',
    'ZWIJNDRECHT',
    'ZWIJNSBERGEN',
    'ZWINDEREN',
    'ZWINGELSPAAN',
    'ZWOLLE',
];
/**
 * Nederlandse namen die precies zo ook in BE, LU, DE of FR bestaan. 498 namen.
 *
 * Hasselt ligt in Overijssel en in Limburg (B), Essen in Noord-Brabant en in het
 * Ruhrgebied. Zo'n naam bewijst niets — de meeste hiervan zijn gewoon de Nederlandse
 * plaats, en Ede, Rutten en Dorst zijn over de grens niet meer dan een gehucht.
 * Daarom is dit geen oordeel maar een vraag; `buitenland.ts` legt uit waar die landt.
 *
 * Namen die alleen ná het weghalen van accenten zouden botsen staan hier níét in, en
 * dat hoeft ook niet meer: die matchen sinds de accentgevoelige vergelijking sowieso
 * niet, en komen dus als buitenland uit de bus in plaats van als twijfel.
 */
export const DUBBELE_NAMEN = [
    'AALST',
    'AARLE',
    'ACHT',
    'ACHTERBERG',
    'ACHTERBOS',
    'ACHTERBROEK',
    'ACHTERHOEK',
    'ALTENA',
    'AMEN',
    'AMERIKA',
    'ANDEL',
    'ANHOLT',
    'ANKUM',
    'ANNEN',
    'ANNEVILLE',
    'APPEL',
    'APPEN',
    'ARRIEN',
    'ASBROEK',
    'ASCH',
    'ASSEL',
    'ASSEN',
    'ASTEN',
    'AUSTERLITZ',
    'BAAK',
    'BAAL',
    'BAARS',
    'BAARSTRAAT',
    'BAKEL',
    'BALLAST',
    'BANT',
    'BARLAGE',
    'BARLO',
    'BASSE',
    'BECKUM',
    'BEEK',
    'BEEKKANT',
    'BEEMDKANT',
    'BEINUM',
    'BERENBROEK',
    'BERG',
    'BERGEN',
    'BERN',
    'BEST',
    'BETHLEHEM',
    'BIERT',
    'BIESTHOEK',
    'BISSEN',
    'BLANKENBERG',
    'BLAUWE SLUIS',
    'BLAUWENHOEK',
    'BLOEMENDAAL',
    'BOEKEL',
    'BOERENHOEK',
    'BOERENHOL',
    'BOKSHEIDE',
    'BORN',
    'BORNE',
    'BOSHOEK',
    'BOSHOVEN',
    'BOSKANT',
    'BOVENBERG',
    'BRAKEL',
    'BRAND',
    'BREM',
    'BRESKENS',
    'BROEK',
    'BROEKHOVEN',
    'BROEKHUIZEN',
    'BROEKKANT',
    'BROEKZIJDE',
    'BRUGGEN',
    'BUCHTEN',
    'BUNDE',
    'BUS',
    'CAPELLE',
    'COLMONT',
    'CREIL',
    'CRÈVECOEUR',
    'DAL',
    'DALEM',
    'DAM',
    'DE BERG',
    'DE DONK',
    'DE HEES',
    'DE HEIDE',
    'DE HEL',
    'DE HOEVE',
    'DE HOEVEN',
    'DE HOUW',
    'DE MAAT',
    'DE MATEN',
    'DE NACHTEGAAL',
    'DE PLAATS',
    'DE VOORT',
    'DEELEN',
    'DEMEN',
    'DEN BERG',
    'DEN HOEK',
    'DEN HOORN',
    'DEN HOUT',
    'DEN HULST',
    'DEN OEVER',
    'DEURNE',
    'DIEPENBROEK',
    'DIESSEN',
    'DIJK',
    'DISTELBERG',
    'DOLBERG',
    'DONK',
    'DOORN',
    'DOORNHOEK',
    'DORP',
    'DORST',
    'DRAAIBRUG',
    'DRIEHOEK',
    'DRIES',
    'DUN',
    'ECHT',
    'EDE',
    'EEKT',
    'EILAND',
    'EINDE',
    'ELL',
    'ELP',
    'ELSEN',
    'ELSHOF',
    'ELSHOUT',
    'ELSLO',
    'ELST',
    'EMMEN',
    'EMPEL',
    'ENG',
    'ENGELAND',
    'ENS',
    'EPE',
    'ERP',
    'ESCH',
    'ESPEL',
    'ESSEN',
    'EST',
    'FLERINGEN',
    'FONS',
    'FORT',
    'FRIESLAND',
    'FROMBERG',
    'GAU',
    'GEBERGTE',
    'GEER',
    'GEES',
    'GENNEP',
    'GIESSEN',
    'GLANE',
    'GOES',
    'GOOR',
    'GRACHT',
    'GRAFHORST',
    'GRAFT',
    'GRAFWEGEN',
    'GRAVE',
    'GRAZEN',
    'GRIETE',
    'GROENENDAAL',
    'GROENENDIJK',
    'GROENSTRAAT',
    'GULPEN',
    'HAAG',
    'HAAREN',
    'HAART',
    'HAELEN',
    'HAL',
    'HALL',
    'HALLE',
    'HALTE',
    'HAM',
    'HANENBERG',
    'HARDENBERG',
    'HAREN',
    'HARLINGEN',
    'HASSELT',
    'HAULE',
    'HAZENNEST',
    'HEEG',
    'HEEK',
    'HEERDE',
    'HEERLE',
    'HEERS',
    'HEERSTRAAT',
    'HEES',
    'HEESAKKER',
    'HEGGE',
    'HEIBLOEM',
    'HEIDE',
    'HEIDEKANT',
    'HEIHOEK',
    'HEIKANT',
    'HEILLE',
    'HEIMOLEN',
    'HEISTRAAT',
    'HEIVELD',
    'HELDEN',
    'HELLE',
    'HELLEGAT',
    'HELLING',
    'HEM',
    'HEMMEN',
    'HERSEL',
    'HERTEN',
    'HET LAAR',
    'HET SAS',
    'HEUKELOM',
    'HEURE',
    'HEURNE',
    'HEUSDEN',
    'HEUVEL',
    'HEUVEN',
    'HILL',
    'HINGEN',
    'HOEF',
    'HOEK',
    'HOEKEINDE',
    'HOEKJE',
    'HOEVE',
    'HOEVEN',
    'HOF',
    'HOGEWEG',
    'HOLLENBERG',
    'HOLT',
    'HOLTE',
    'HOLTEN',
    'HOLTLAND',
    'HOLTUM',
    'HOMBERG',
    'HOMMERT',
    'HONDSEIND',
    'HONTHEM',
    'HOOGEIND',
    'HOOGLAND',
    'HOOGSTRAAT',
    'HOOGVELD',
    'HOOIDONK',
    'HOOL',
    'HORN',
    'HORST',
    'HORSTEN',
    'HOUTHEM',
    'HOUTHUIZEN',
    'HUB',
    'HULSBEEK',
    'HULSEL',
    'HULSEN',
    'HULST',
    'HUNSEL',
    'JONAS',
    'KAAG',
    'KADE',
    'KADIJK',
    'KALENBERG',
    'KALISHOEK',
    'KAMP',
    'KAMPEN',
    'KAPEL',
    'KAPELLE',
    'KATTENBERG',
    'KEIZERSHOEK',
    'KESSEL',
    'KIJKUIT',
    'KLEEBERG',
    'KLEF',
    'KLEI',
    'KLINKENBERG',
    'KLOOSTER',
    'KOEKOEK',
    'KOEWACHT',
    'KORTRIJK',
    'KRABBENHOEK',
    'KRANENBURG',
    'KRUISBERG',
    'KRUISSTRAAT',
    'KRUISWEG',
    'LAAGSTRAAT',
    'LAAK',
    'LAAR',
    'LANGE HEIDE',
    'LANGENBERG',
    'LANGSTRAAT',
    'LAREN',
    'LENT',
    'LENTHE',
    'LEPELSTRAAT',
    'LEUTH',
    'LEUVEN',
    'LIEFKENSHOEK',
    'LIES',
    'LIESSEL',
    'LINDE',
    'LINDEN',
    'LINNE',
    'LISSE',
    'LOCHT',
    'LOPPERSUM',
    'LUTTEN',
    'MAAGD VAN GENT',
    'MAALBROEK',
    'MARIENBERG',
    'MARLE',
    'MECHELEN',
    'MEER',
    'MEEUWEN',
    'MENZEL',
    'MEPPEN',
    'MIDDELBURG',
    'MIDLUM',
    'MILLINGEN',
    'MOERDIJK',
    'MOLENEIND',
    'MOLENHOEK',
    'MOLENSTRAAT',
    'MOLENVELD',
    'MOLENWIJK',
    'MOLSBERG',
    'MONTFORT',
    'MOORSEL',
    'MOSKOU',
    'MOST',
    'MUGGENBERG',
    'MUIZENHOL',
    'MUN',
    'MUNEIN',
    'MUSSEL',
    'NACHTEGAAL',
    'NEDERHEIDE',
    'NEERBROEK',
    'NEERDORP',
    'NEERSTRAAT',
    'NERGENA',
    'NIEUWDORP',
    'NIEUWEBRUG',
    'NIEUWENDIJK',
    'NIEUWLAND',
    'NIEUWPOORT',
    'NIEUWSTAD',
    'NIJKEN',
    'NOORDEIND',
    'NOORDHOEK',
    'NOORDSTRAAT',
    'OLEN',
    'OOSTEINDE',
    'OOSTERWIJK',
    'OOSTHOEK',
    'OPHOVEN',
    'OUDENDIJK',
    'OUDENMOLEN',
    'OVERBERG',
    'OVERBROEK',
    'OVERSLAG',
    'OVERWATER',
    'PAAL',
    'PARK',
    'PELIKAAN',
    'PETERSBURG',
    'PLAAT',
    'PLANTAGE',
    'PLEIN',
    'POLLE',
    'PONTE',
    'POSTHOORN',
    'PUTTE',
    'QUATRE BRAS',
    'RAAM',
    'RAVENSTEIN',
    'RESSEN',
    'RETH',
    'REUTH',
    'RHEDEN',
    'RIED',
    'RIEL',
    'RIJKEL',
    'RODE SLUIS',
    'RODEN',
    'ROME',
    'ROTHENBACH',
    'ROTT',
    'ROTTUM',
    'RULLEN',
    'RUTTEN',
    'SCHAGEN',
    'SCHANS',
    'SCHOKLAND',
    'SCHOONHOVEN',
    'SCHOOR',
    'SCHOOT',
    'SCHORE',
    'SCHUDDEBEURS',
    'SINT ANDRIES',
    'SINT KRUIS',
    'SION',
    'SITTARD',
    'SLUIS',
    'SOEST',
    'SON',
    'SPIESBERG',
    'STEDUM',
    'STEEG',
    'STEENBERGEN',
    'STEENDAM',
    'STEENHOVEN',
    'STEENSEL',
    'STEGEN',
    'STEIN',
    'STOKT',
    'STOLPEN',
    'STORK',
    'STRAND',
    'STRATEN',
    'STREEK',
    'STROOIENDORP',
    'T ZAND',
    'TEMPEL',
    'TERBORG',
    'TERHAGEN',
    'TERLINDEN',
    'TERSTRATEN',
    'TERVOORT',
    'TONGEREN',
    'TONGERLO',
    'TRENT',
    'ULVEND',
    'VAART',
    'VEEN',
    'VELD',
    'VELDEN',
    'VELDHOEK',
    'VELDHOVEN',
    'VEN',
    'VENNE',
    'VERLORENHOEK',
    'VEULEN',
    'VIEL',
    'VIERHUIZEN',
    'VIERUITERSTEN',
    'VIJFHOEK',
    'VIJFHUIZEN',
    'VINK',
    'VINKENBERG',
    'VINKWIJK',
    'VLIET',
    'VOGELENZANG',
    'VOGELZANG',
    'VOORHOUT',
    'VOORT',
    'VORST',
    'VOSBERG',
    'VOSSEBERG',
    'VOSSENBERG',
    'VUILPAN',
    'WAAL',
    'WAARDE',
    'WACHTUM',
    'WALEM',
    'WAMBERG',
    'WAMEL',
    'WARDER',
    'WATERHOEK',
    'WATERINGEN',
    'WATERKANT',
    'WATERVAL',
    'WAVER',
    'WEEG',
    'WEENDE',
    'WEERT',
    'WEG',
    'WEHL',
    'WELL',
    'WERKHOVEN',
    'WESTEINDE',
    'WESTERBROEK',
    'WESTERHORN',
    'WESTERLAND',
    'WESTHOEK',
    'WESTKAPELLE',
    'WESTKERKE',
    'WEZEL',
    'WILDERT',
    'WILSUM',
    'WINDESHEIM',
    'WINKEL',
    'WIRDUM',
    'WISSEL',
    'WITTEN',
    'WOLFHAGEN',
    'WOLFSWINKEL',
    'ZAND',
    'ZANDBERG',
    'ZANDSTRAAT',
    'ZEVENHUIZEN',
    'ZWAANTJE',
    'ZWIJNDRECHT',
];
//# sourceMappingURL=woonplaatsen.js.map